var qt = Object.defineProperty;
var Ut = (e, t, r) => t in e ? qt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var B = (e, t, r) => Ut(e, typeof t != "symbol" ? t + "" : t, r);
import { create as Dt } from "zustand";
import { persist as Ht, createJSONStorage as Gt } from "zustand/middleware";
import Pe, { HTTPError as ut } from "ky";
import { jsx as s, jsxs as L, Fragment as ee } from "react/jsx-runtime";
import jt, { useCallback as E, useState as P, useEffect as H, useMemo as ve, useRef as $, useContext as mt, createContext as gt } from "react";
import { Button as V, Box as ke, Center as re, Loader as Oe, Text as N, Alert as de, Stack as F, Divider as We, Group as oe, SegmentedControl as $t, TextInput as pe, PasswordInput as je, Anchor as _e, Modal as Ke, useMantineTheme as Bt, useComputedColorScheme as Vt, Paper as Wt, Title as ht, Progress as rt, ThemeIcon as Je, Checkbox as Kt, Avatar as Jt, Menu as Z, UnstyledButton as Yt } from "@mantine/core";
import { IconBrandGoogle as ot, IconBrandFacebook as nt, IconAlertCircle as Ne, IconMail as xe, IconLock as ze, IconShieldCheck as Zt, IconCheck as ft, IconX as Qt, IconUser as pt, IconArrowLeft as Xt, IconHome as er, IconShoppingCart as tr, IconWallet as rr, IconChevronDown as or, IconLogout as nr } from "@tabler/icons-react";
import { useTranslation as G } from "react-i18next";
import { useForm as $e } from "@mantine/form";
import { z as W } from "zod";
import { useDisclosure as ir, useMediaQuery as ar } from "@mantine/hooks";
import { notifications as sr } from "@mantine/notifications";
const _t = ["admin", "super_admin"], lr = ["merchant_owner", "merchant_admin"], Un = [..._t, ...lr], we = "teletienda-auth", cr = "teletienda-auth-sync", De = "tt-auth-sync", dr = 2e3, ur = 30 * 24 * 60 * 60, mr = ".teletienda.ar";
let be = null;
function gr() {
  return typeof window > "u" ? !1 : window.location.hostname.endsWith(".teletienda.ar");
}
function hr() {
  if (typeof window > "u") return "localhost";
  const e = window.location.hostname;
  return e.endsWith(".teletienda.ar") ? mr : e.endsWith(".teletienda.local") ? ".teletienda.local" : e;
}
function wt() {
  const e = gr() || typeof window < "u" && window.location.protocol === "https:";
  return {
    cookieDomain: hr(),
    secure: e,
    sameSite: "lax",
    maxAge: ur,
    storageKey: we
  };
}
function ue() {
  return be || (be = wt()), be;
}
function Dn(e) {
  be = {
    ...wt(),
    ...e
  };
}
function Hn() {
  be = null;
}
function fr() {
  const e = /* @__PURE__ */ new Map();
  if (typeof document > "u")
    return e;
  const t = document.cookie.split(";");
  for (const r of t) {
    const [o, ...i] = r.split("=");
    if (o) {
      const n = o.trim(), a = i.join("=").trim();
      if (n)
        try {
          e.set(n, decodeURIComponent(a));
        } catch {
          e.set(n, a);
        }
    }
  }
  return e;
}
function Ae(e) {
  return fr().get(e) ?? null;
}
function Ye(e, t, r) {
  if (typeof document > "u")
    return;
  const o = ue(), i = {
    domain: (r == null ? void 0 : r.domain) ?? o.cookieDomain,
    path: (r == null ? void 0 : r.path) ?? "/",
    maxAge: (r == null ? void 0 : r.maxAge) ?? o.maxAge,
    secure: (r == null ? void 0 : r.secure) ?? o.secure,
    sameSite: (r == null ? void 0 : r.sameSite) ?? o.sameSite
  }, n = [
    `${encodeURIComponent(e)}=${encodeURIComponent(t)}`,
    `path=${i.path}`,
    `max-age=${i.maxAge}`,
    `samesite=${i.sameSite}`
  ];
  i.domain && i.domain !== "localhost" && n.push(`domain=${i.domain}`), i.secure && n.push("secure"), document.cookie = n.join("; ");
}
function Se(e, t) {
  if (typeof document > "u")
    return;
  const r = ue(), o = t ?? r.cookieDomain, i = [
    `${encodeURIComponent(e)}=`,
    "path=/",
    "max-age=0",
    "expires=Thu, 01 Jan 1970 00:00:00 GMT"
  ];
  o && o !== "localhost" && i.push(`domain=${o}`), document.cookie = i.join("; ");
}
function pr() {
  if (typeof document > "u")
    return !1;
  try {
    const e = "__tt_cookie_test__";
    document.cookie = `${e}=1; path=/`;
    const t = document.cookie.includes(e);
    return document.cookie = `${e}=; path=/; max-age=0`, t;
  } catch {
    return !1;
  }
}
function Gn(e, t, r) {
  const o = JSON.stringify(t);
  Ye(e, o, r);
}
function jn(e) {
  const t = Ae(e);
  if (!t)
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}
class _r {
  constructor() {
    B(this, "channel", null);
    B(this, "handlers", /* @__PURE__ */ new Set());
    B(this, "useFallback", !1);
    B(this, "boundStorageHandler", null);
    this.init();
  }
  /**
   * Initialize sync mechanism
   */
  init() {
    if (!(typeof window > "u")) {
      if ("BroadcastChannel" in window)
        try {
          this.channel = new BroadcastChannel(cr), this.channel.onmessage = (t) => {
            this.notifyHandlers(t.data);
          };
          return;
        } catch {
        }
      this.useFallback = !0, this.boundStorageHandler = this.handleStorageEvent.bind(this), window.addEventListener("storage", this.boundStorageHandler);
    }
  }
  /**
   * Handle storage event (fallback mechanism)
   */
  handleStorageEvent(t) {
    if (t.key === `${we}-sync` && t.newValue)
      try {
        const r = JSON.parse(t.newValue);
        this.notifyHandlers(r);
      } catch {
      }
  }
  /**
   * Notify all registered handlers
   */
  notifyHandlers(t) {
    for (const r of this.handlers)
      try {
        r(t);
      } catch (o) {
        console.error("[shared-auth-ui] Sync handler error:", o);
      }
  }
  /**
   * Subscribe to sync events
   *
   * @param handler Event handler function
   * @returns Unsubscribe function
   */
  subscribe(t) {
    return this.handlers.add(t), () => {
      this.handlers.delete(t);
    };
  }
  /**
   * Broadcast a sync event to other tabs
   *
   * @param type Event type
   * @param data Optional event data
   */
  broadcast(t, r) {
    const o = {
      type: t,
      timestamp: Date.now(),
      data: r
    };
    if (this.channel)
      this.channel.postMessage(o);
    else if (this.useFallback && typeof localStorage < "u")
      try {
        localStorage.setItem(`${we}-sync`, JSON.stringify(o)), localStorage.removeItem(`${we}-sync`);
      } catch {
      }
  }
  /**
   * Broadcast login event
   */
  broadcastLogin() {
    this.broadcast("login");
  }
  /**
   * Broadcast logout event
   */
  broadcastLogout() {
    this.broadcast("logout");
  }
  /**
   * Broadcast token refresh event
   */
  broadcastTokenRefresh() {
    this.broadcast("token_refresh");
  }
  /**
   * Clean up resources
   */
  destroy() {
    this.channel && (this.channel.close(), this.channel = null), this.boundStorageHandler && typeof window < "u" && (window.removeEventListener("storage", this.boundStorageHandler), this.boundStorageHandler = null), this.handlers.clear();
  }
  /**
   * Check if BroadcastChannel is being used (vs fallback)
   */
  isUsingBroadcastChannel() {
    return this.channel !== null;
  }
}
let ie = null;
function Fe() {
  return ie || (ie = new _r()), ie;
}
function $n() {
  ie && (ie.destroy(), ie = null);
}
function wr(e) {
  return Fe().subscribe(e);
}
function br() {
  Fe().broadcastLogin();
}
function it() {
  Fe().broadcastLogout();
}
function yr() {
  Fe().broadcastTokenRefresh();
}
class vr {
  constructor() {
    B(this, "handlers", /* @__PURE__ */ new Set());
    B(this, "pollInterval", null);
    B(this, "lastSeenTimestamp", 0);
    B(this, "currentOrigin", "");
    typeof window < "u" && (this.currentOrigin = window.location.origin, this.initializeFromCookie());
  }
  /**
   * Initialize from existing cookie
   * Does NOT set lastSeenTimestamp - that's handled by checkPendingEvents
   */
  initializeFromCookie() {
  }
  /**
   * Check if there's a pending sync event from another origin
   * that we missed (e.g., page was reloaded after logout on another subdomain)
   * Returns the pending event data if found, null otherwise
   */
  getPendingEvent() {
    const t = Ae(De);
    if (!t)
      return null;
    try {
      const r = JSON.parse(t);
      return r.origin === this.currentOrigin || r.timestamp <= this.lastSeenTimestamp ? null : r;
    } catch {
      return null;
    }
  }
  /**
   * Start polling for cross-subdomain sync events
   */
  startPolling() {
    this.pollInterval || typeof window > "u" || (this.pollInterval = setInterval(() => {
      this.checkForChanges();
    }, dr));
  }
  /**
   * Stop polling
   */
  stopPolling() {
    this.pollInterval && (clearInterval(this.pollInterval), this.pollInterval = null);
  }
  /**
   * Check cookie for changes from other subdomains
   */
  checkForChanges() {
    const t = Ae(De);
    if (t)
      try {
        const r = JSON.parse(t);
        if (r.origin === this.currentOrigin || r.timestamp <= this.lastSeenTimestamp)
          return;
        this.lastSeenTimestamp = r.timestamp;
        const o = {
          type: r.type,
          timestamp: r.timestamp
        };
        this.notifyHandlers(o);
      } catch {
      }
  }
  /**
   * Notify all registered handlers
   */
  notifyHandlers(t) {
    for (const r of this.handlers)
      try {
        r(t);
      } catch (o) {
        console.error("[shared-auth-ui] Cross-subdomain sync handler error:", o);
      }
  }
  /**
   * Subscribe to cross-subdomain sync events
   *
   * @param handler Event handler function
   * @returns Unsubscribe function
   */
  subscribe(t) {
    if (this.handlers.add(t), this.handlers.size === 1) {
      this.startPolling();
      const r = this.getPendingEvent();
      r && (this.lastSeenTimestamp = r.timestamp, setTimeout(() => {
        const o = {
          type: r.type,
          timestamp: r.timestamp
        };
        t(o);
      }, 0));
    }
    return () => {
      this.handlers.delete(t), this.handlers.size === 0 && this.stopPolling();
    };
  }
  /**
   * Broadcast a sync event to other subdomains via cookie
   *
   * @param type Event type
   */
  broadcast(t) {
    if (typeof window > "u")
      return;
    const r = {
      type: t,
      timestamp: Date.now(),
      origin: this.currentOrigin
    };
    this.lastSeenTimestamp = r.timestamp, Ye(De, JSON.stringify(r), {
      maxAge: 5 * 60
      // 5 minutes
    });
  }
  /**
   * Broadcast login event to other subdomains
   */
  broadcastLogin() {
    this.broadcast("login");
  }
  /**
   * Broadcast logout event to other subdomains
   */
  broadcastLogout() {
    this.broadcast("logout");
  }
  /**
   * Broadcast token refresh event to other subdomains
   */
  broadcastTokenRefresh() {
    this.broadcast("token_refresh");
  }
  /**
   * Clean up resources
   */
  destroy() {
    this.stopPolling(), this.handlers.clear();
  }
  /**
   * Check if currently polling
   */
  isPolling() {
    return this.pollInterval !== null;
  }
}
let ae = null;
function qe() {
  return ae || (ae = new vr()), ae;
}
function Bn() {
  ae && (ae.destroy(), ae = null);
}
function kr(e) {
  return qe().subscribe(e);
}
function Ar() {
  qe().broadcastLogin();
}
function Tr() {
  qe().broadcastLogout();
}
function Cr() {
  qe().broadcastTokenRefresh();
}
const Ue = "tt-auth-slim", Me = 3072, ye = 4096;
function Sr(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = e;
  return typeof t.token == "string" && typeof t.refreshToken == "string" && typeof t.userGuid == "string" && typeof t.isAuthenticated == "boolean" && typeof t.expiresAt == "number";
}
function bt(e) {
  return typeof Blob < "u" ? new Blob([e]).size : new TextEncoder().encode(e).length;
}
function yt() {
  const e = Ae(Ue), t = e ? bt(e) : 0;
  return {
    currentSize: t,
    maxSize: ye,
    warningThreshold: Me,
    isOverWarning: t > Me,
    isOverLimit: t > ye,
    percentUsed: Math.round(t / ye * 100)
  };
}
function Er(e) {
  const t = JSON.stringify(e), r = bt(t);
  return r > ye ? (console.error(
    `[SlimCookie] Cookie size (${r} bytes) exceeds maximum (${ye} bytes). Cookie will NOT be set to prevent silent browser rejection.`
  ), !1) : (r > Me && console.warn(
    `[SlimCookie] Cookie size (${r} bytes) exceeds warning threshold (${Me} bytes). Consider reducing stored data.`
  ), Ye(Ue, t), !0);
}
function me() {
  const e = Ae(Ue);
  if (!e)
    return null;
  try {
    const t = JSON.parse(e);
    return Sr(t) ? t : (console.warn("[SlimCookie] Cookie contains invalid SlimAuthData structure"), null);
  } catch (t) {
    return console.warn("[SlimCookie] Failed to parse cookie JSON:", t), null;
  }
}
function se() {
  Se(Ue);
}
let K = {
  timeout: 3e4
}, Ee = null;
function Rr(e) {
  K = {
    ...K,
    ...e
  }, Ee = Pe.create({
    prefixUrl: K.baseUrl,
    timeout: K.timeout,
    hooks: {
      beforeRequest: [
        (t) => {
          if (K.getToken) {
            const r = K.getToken();
            r && t.headers.set("Authorization", `Bearer ${r}`);
          }
        }
      ]
    }
  });
}
function J() {
  return Ee || (Ee = Pe.create({
    timeout: K.timeout,
    hooks: {
      beforeRequest: [
        (e) => {
          if (K.getToken) {
            const t = K.getToken();
            t && e.headers.set("Authorization", `Bearer ${t}`);
          }
        }
      ]
    }
  })), Ee;
}
function Vn() {
  return { ...K };
}
function Ir(e) {
  K.getToken = e;
}
function Y(e) {
  var t;
  return {
    userGuid: e.user_guid,
    email: e.email || e.notification_email || e.notificationEmail,
    name: e.display_name || e.first_name || ((t = e.email) == null ? void 0 : t.split("@")[0]) || "",
    firstName: e.first_name,
    lastName: e.last_name,
    phone: e.phone,
    avatarUrl: e.avatar || e.avatar_url,
    roles: e.roles || [],
    permissions: e.permissions || [],
    merchantGuid: e.merchant_guid,
    merchantGuids: e.merchant_guids,
    preferred_currency: e.preferred_currency,
    languageCode: e.language_code
  };
}
function Lr() {
  const e = {
    localStorage: !1,
    cookies: !1,
    broadcastChannel: !1,
    slimCookieSize: 0,
    slimCookieHealthy: !0
  };
  if (typeof window < "u" && window.localStorage)
    try {
      const r = "__tt_storage_test__";
      localStorage.setItem(r, "1"), localStorage.removeItem(r), e.localStorage = !0;
    } catch {
    }
  e.cookies = pr(), typeof window < "u" && "BroadcastChannel" in window && (e.broadcastChannel = !0);
  const t = yt();
  return e.slimCookieSize = t.currentSize, e.slimCookieHealthy = !t.isOverWarning, e;
}
function Wn() {
  if (typeof window > "u")
    return !1;
  try {
    const e = "__tt_private_test__";
    return localStorage.setItem(e, "1"), localStorage.removeItem(e), "storage" in navigator && "estimate" in navigator.storage, !1;
  } catch {
    return !0;
  }
}
function Re(e) {
  const t = ue();
  return e === t.storageKey || e.startsWith(t.storageKey) ? e : `${t.storageKey}-${e}`;
}
async function vt(e) {
  try {
    const r = await J().get("api/v1/users/me", {
      headers: {
        Authorization: `Bearer ${e}`
      }
    }).json();
    return r.success && r.data ? Y(r.data) : (console.warn("[AuthStorage] hydrateFromApi: Invalid response format"), null);
  } catch (t) {
    return t instanceof Error && t.message.includes("401") || console.warn("[AuthStorage] hydrateFromApi failed:", t), null;
  }
}
function Pr(e) {
  if (!e || typeof e != "object")
    return !1;
  const r = e.user;
  return r ? Array.isArray(r.roles) && Array.isArray(r.permissions) && typeof r.email == "string" : !1;
}
function Kn() {
  const e = ue(), t = Re(e.storageKey);
  if (typeof window < "u" && window.localStorage)
    try {
      const o = localStorage.getItem(t);
      if (o) {
        const i = JSON.parse(o);
        if (Pr(i == null ? void 0 : i.state))
          return !1;
      }
    } catch {
    }
  const r = me();
  return r !== null && r.isAuthenticated;
}
class Or {
  constructor() {
    B(this, "cookiesAvailable");
    B(this, "localStorageAvailable");
    const t = Lr();
    this.cookiesAvailable = t.cookies, this.localStorageAvailable = t.localStorage, !this.localStorageAvailable && !this.cookiesAvailable ? console.warn("[shared-auth-ui] No storage available. Auth state will not persist.") : this.cookiesAvailable || console.warn("[shared-auth-ui] Cookies disabled. Cross-subdomain SSO will not work.");
  }
  /**
   * Get item from storage
   * Split persistence: localStorage (full data) -> slim cookie (cross-subdomain)
   *
   * @param name Storage key
   * @returns Stored value or null
   */
  getItem(t) {
    var i, n, a;
    const r = Re(t);
    let o = null;
    if (this.localStorageAvailable)
      try {
        o = localStorage.getItem(r);
      } catch {
      }
    if (o !== null)
      try {
        const l = JSON.parse(o);
        if (((i = l == null ? void 0 : l.state) == null ? void 0 : i.isAuthenticated) === !0)
          return o;
      } catch {
      }
    if (this.cookiesAvailable) {
      const l = me();
      if (l && l.isAuthenticated)
        try {
          const d = o ? JSON.parse(o) : null;
          if (!(((n = d == null ? void 0 : d.state) == null ? void 0 : n.isAuthenticated) === !0)) {
            const f = {
              state: {
                user: { userGuid: l.userGuid },
                token: l.token,
                refreshToken: l.refreshToken,
                expiresAt: l.expiresAt,
                isAuthenticated: !0,
                isLoading: !1,
                _needsHydration: !0
                // Internal marker
              },
              version: 0
            };
            return JSON.stringify(f);
          }
        } catch {
          const d = {
            state: {
              user: { userGuid: l.userGuid },
              token: l.token,
              refreshToken: l.refreshToken,
              expiresAt: l.expiresAt,
              isAuthenticated: !0,
              isLoading: !1,
              _needsHydration: !0
            },
            version: 0
          };
          return JSON.stringify(d);
        }
      else if (l && !l.isAuthenticated && o)
        try {
          const d = JSON.parse(o);
          if (((a = d == null ? void 0 : d.state) == null ? void 0 : a.isAuthenticated) === !0) {
            const u = {
              state: {
                user: null,
                token: null,
                refreshToken: null,
                expiresAt: null,
                isAuthenticated: !1,
                isLoading: !1
              },
              version: 0
            };
            if (this.localStorageAvailable)
              try {
                localStorage.setItem(r, JSON.stringify(u));
              } catch {
              }
            return JSON.stringify(u);
          }
        } catch {
        }
    }
    return o !== null ? o : null;
  }
  /**
   * Set item in storage
   * Split persistence: full data to localStorage, slim data to cookie
   *
   * @param name Storage key
   * @param value Value to store
   */
  setItem(t, r) {
    var i;
    const o = Re(t);
    if (this.localStorageAvailable)
      try {
        localStorage.setItem(o, r);
      } catch (n) {
        if (this.isQuotaExceededError(n)) {
          this.handleQuotaExceeded();
          try {
            localStorage.setItem(o, r);
          } catch {
          }
        }
      }
    if (this.cookiesAvailable)
      try {
        const n = JSON.parse(r), a = n == null ? void 0 : n.state, l = (i = a == null ? void 0 : a.user) == null ? void 0 : i.userGuid;
        if (a != null && a.token && l) {
          if (!a.expiresAt)
            return;
          const d = {
            token: a.token,
            refreshToken: a.refreshToken || "",
            userGuid: l,
            isAuthenticated: a.isAuthenticated ?? !0,
            expiresAt: a.expiresAt
          };
          Er(d);
        } else a != null && a.isAuthenticated || se();
      } catch {
      }
  }
  /**
   * Remove item from storage
   * Removes from localStorage, legacy cookie, and slim cookie
   *
   * @param name Storage key
   */
  removeItem(t) {
    const r = Re(t);
    if (this.localStorageAvailable)
      try {
        localStorage.removeItem(r);
      } catch {
      }
    this.cookiesAvailable && (Se(r), se());
  }
  /**
   * Clear all auth-related data
   */
  clear() {
    const t = ue();
    if (this.localStorageAvailable)
      try {
        const r = [];
        for (let o = 0; o < localStorage.length; o++) {
          const i = localStorage.key(o);
          i && i.startsWith(t.storageKey) && r.push(i);
        }
        r.forEach((o) => localStorage.removeItem(o));
      } catch {
      }
    this.cookiesAvailable && (Se(t.storageKey), Se(`${t.storageKey}-sync`), se()), it();
  }
  /**
   * Check if error is quota exceeded
   */
  isQuotaExceededError(t) {
    return t instanceof DOMException && (t.code === 22 || // Legacy
    t.code === 1014 || // Firefox
    t.name === "QuotaExceededError" || t.name === "NS_ERROR_DOM_QUOTA_REACHED");
  }
  /**
   * Handle storage quota exceeded
   * Clears old data to make room
   */
  handleQuotaExceeded() {
    console.warn("[shared-auth-ui] Storage quota exceeded. Clearing old data.");
    const t = ue();
    try {
      const r = [];
      for (let o = 0; o < localStorage.length; o++) {
        const i = localStorage.key(o);
        i && i.startsWith(t.storageKey) && i !== t.storageKey && r.push(i);
      }
      r.forEach((o) => localStorage.removeItem(o));
    } catch {
    }
  }
  /**
   * Get storage health status
   */
  getHealth() {
    const t = yt();
    return {
      localStorage: this.localStorageAvailable,
      cookies: this.cookiesAvailable,
      broadcastChannel: typeof window < "u" && "BroadcastChannel" in window,
      slimCookieSize: t.currentSize,
      slimCookieHealthy: !t.isOverWarning
    };
  }
  /**
   * Notify other tabs of login
   * Uses both BroadcastChannel (same origin) and cookie (cross-subdomain)
   */
  notifyLogin() {
    br(), Ar();
  }
  /**
   * Notify other tabs of logout
   * Uses both BroadcastChannel (same origin) and cookie (cross-subdomain)
   */
  notifyLogout() {
    it(), Tr();
  }
  /**
   * Notify other tabs of token refresh
   * Uses both BroadcastChannel (same origin) and cookie (cross-subdomain)
   */
  notifyTokenRefresh() {
    yr(), Cr();
  }
}
let Ie = null;
function le() {
  return Ie || (Ie = new Or()), Ie;
}
function Jn() {
  Ie = null;
}
function xr() {
  return le();
}
const zr = we, ge = {
  user: null,
  token: null,
  refreshToken: null,
  expiresAt: null,
  isAuthenticated: !1,
  isLoading: !1
};
let Be = null;
function Yn(e) {
  Be = e;
}
function Mr() {
  return Be || xr();
}
const Nr = (e, t) => ({
  ...ge,
  login: (r, o, i, n) => {
    const a = Date.now() + i * 1e3;
    e({
      token: r,
      refreshToken: o,
      expiresAt: a,
      user: n,
      isAuthenticated: !0,
      isLoading: !1
    }), le().notifyLogin();
  },
  logout: () => {
    e(ge), le().notifyLogout();
  },
  updateToken: (r, o, i) => {
    const n = Date.now() + o * 1e3;
    e({
      token: r,
      expiresAt: n,
      ...i && { refreshToken: i }
    }), le().notifyTokenRefresh();
  },
  updateUser: (r) => {
    e({ user: r });
  },
  setLoading: (r) => {
    e({ isLoading: r });
  },
  hasRole: (r) => {
    const { user: o } = t();
    return o ? o.roles.includes(r) : !1;
  },
  hasAnyRole: (r) => {
    const { user: o } = t();
    return o ? r.some((i) => o.roles.includes(i)) : !1;
  },
  hasPermission: (r) => {
    const { user: o } = t();
    return o ? _t.some((i) => o.roles.includes(i)) ? !0 : o.permissions.includes(r) : !1;
  }
}), Fr = {
  name: zr,
  storage: Gt(() => Mr()),
  partialize: (e) => ({
    user: e.user,
    token: e.token,
    refreshToken: e.refreshToken,
    expiresAt: e.expiresAt,
    isAuthenticated: e.isAuthenticated
  })
}, y = Dt()(
  Ht(Nr, Fr)
);
let He = !1;
async function at(e, t = 3, r = !1) {
  for (let o = 0; o < t; o++) {
    if (await y.persist.rehydrate(), y.getState().isAuthenticated === e)
      return;
    !r && o < t - 1 && await new Promise((n) => setTimeout(n, 500 * Math.pow(2, o)));
  }
  console.warn("[shared-auth-ui] Rehydrate retry exhausted, state may be stale");
}
function qr() {
  var r;
  const e = me();
  if (!(e != null && e.isAuthenticated) || !(e != null && e.token))
    return !1;
  const t = y.getState();
  return (r = t.user) != null && r.userGuid && e.userGuid && t.user.userGuid !== e.userGuid ? (console.debug("[shared-auth-ui] UserGuid mismatch - forcing hydration"), !0) : !(t.isAuthenticated && t.user && Array.isArray(t.user.roles) && t.user.roles.length > 0);
}
async function Ur() {
  var o, i, n;
  const e = me();
  if (!(e != null && e.token) || !(e != null && e.isAuthenticated))
    return;
  const t = y.getState(), r = !((o = t.user) != null && o.userGuid) || t.user.userGuid === e.userGuid;
  if (!(t.isAuthenticated && ((n = (i = t.user) == null ? void 0 : i.roles) != null && n.length) && r)) {
    console.debug(r ? "[shared-auth-ui] Performing initial hydration from slim cookie" : "[shared-auth-ui] Performing initial hydration - userGuid mismatch detected"), y.setState({
      token: e.token,
      refreshToken: e.refreshToken,
      expiresAt: e.expiresAt,
      isAuthenticated: !0,
      isLoading: !0,
      user: null
    });
    try {
      const a = await vt(e.token);
      a ? (y.setState({ user: a, isLoading: !1 }), console.debug("[shared-auth-ui] Initial hydration successful")) : (y.setState(ge), se(), console.debug("[shared-auth-ui] Initial hydration failed - token invalid"));
    } catch (a) {
      console.warn("[shared-auth-ui] Initial hydration error:", a), y.setState(ge);
    }
  }
}
function Dr() {
  if (He)
    return console.debug("[shared-auth-ui] Sync already initialized"), () => {
    };
  He = !0, qr() && Ur();
  const e = async (o) => {
    const i = y.getState();
    switch (o.type) {
      case "logout":
        i.isAuthenticated && y.setState(ge), se(), setTimeout(() => at(!1), 500);
        break;
      case "login": {
        const n = me();
        if (!(n != null && n.token) || !(n != null && n.isAuthenticated)) {
          console.debug("[shared-auth-ui] Cross-subdomain login: no slim cookie, retrying"), setTimeout(() => at(!0), 500);
          return;
        }
        console.debug("[shared-auth-ui] Cross-subdomain login: validating token before state update"), y.setState({
          isLoading: !0
        });
        try {
          const a = await vt(n.token);
          a ? (console.debug("[shared-auth-ui] Cross-subdomain login: token validated, updating state"), y.setState({
            token: n.token,
            refreshToken: n.refreshToken,
            expiresAt: n.expiresAt,
            isAuthenticated: !0,
            isLoading: !1,
            user: a
          })) : (console.warn("[shared-auth-ui] Cross-subdomain login: token invalid, clearing state"), y.setState(ge), se());
        } catch (a) {
          console.warn("[shared-auth-ui] Cross-subdomain login: API error", a), y.setState({ isLoading: !1 });
        }
        break;
      }
      case "token_refresh": {
        const n = me();
        n != null && n.token && y.setState({
          token: n.token,
          expiresAt: n.expiresAt
        }), setTimeout(() => y.persist.rehydrate(), 500);
        break;
      }
    }
  }, t = wr(e), r = kr(e);
  return () => {
    He = !1, t(), r();
  };
}
function Zn() {
  const { expiresAt: e } = y.getState();
  if (!e) return !1;
  const t = 2 * 60 * 1e3;
  return Date.now() >= e - t;
}
function Qn() {
  const { expiresAt: e } = y.getState();
  return e ? Date.now() >= e : !0;
}
function ce() {
  le().clear();
}
function Xn() {
  return le().getHealth();
}
class R extends Error {
  constructor(r, o, i, n) {
    super(r);
    B(this, "code");
    B(this, "status");
    B(this, "details");
    this.name = "AuthApiError", this.code = o, this.status = i, this.details = n;
  }
}
async function he(e) {
  var t, r, o;
  if (e instanceof ut)
    try {
      const i = await e.response.json();
      throw new R(
        ((t = i.error) == null ? void 0 : t.message) || e.message,
        ((r = i.error) == null ? void 0 : r.code) || "HTTP_ERROR",
        e.response.status,
        (o = i.error) == null ? void 0 : o.details
      );
    } catch (i) {
      throw i instanceof R ? i : new R(
        e.message,
        "HTTP_ERROR",
        e.response.status
      );
    }
  throw e instanceof Error ? new R(
    e.message,
    "NETWORK_ERROR",
    0
  ) : new R(
    "Unknown error",
    "UNKNOWN_ERROR",
    0
  );
}
async function Hr(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.post("api/v1/auth/login", {
      json: e
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Login failed",
        ((o = n.error) == null ? void 0 : o.code) || "LOGIN_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return he(n);
  }
}
async function kt(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.post("api/v1/auth/register", {
      json: e
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Registration failed",
        ((o = n.error) == null ? void 0 : o.code) || "REGISTRATION_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return he(n);
  }
}
async function Ze(e) {
  var r, o, i;
  const t = J();
  try {
    const n = { refreshToken: e }, a = await t.post("api/v1/auth/refresh-token", {
      json: n
    }).json();
    if (!a.success || !a.data)
      throw new R(
        ((r = a.error) == null ? void 0 : r.message) || "Token refresh failed",
        ((o = a.error) == null ? void 0 : o.code) || "REFRESH_FAILED",
        400,
        (i = a.error) == null ? void 0 : i.details
      );
    return a.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return he(n);
  }
}
async function Gr(e) {
  const t = J();
  try {
    const r = { refreshToken: e };
    await t.post("api/v1/auth/logout", {
      json: r,
      timeout: 5e3
      // Short timeout for logout
    });
  } catch {
  }
}
async function jr(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.post("api/v1/auth/request-login-code", {
      json: { email: e }
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Failed to request login code",
        ((o = n.error) == null ? void 0 : o.code) || "REQUEST_CODE_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return he(n);
  }
}
async function $r(e, t) {
  var o, i, n;
  const r = J();
  try {
    const a = await r.post("api/v1/auth/login-by-code", {
      json: { email: e, code: t }
    }).json();
    if (!a.success || !a.data)
      throw new R(
        ((o = a.error) == null ? void 0 : o.message) || "Login by code failed",
        ((i = a.error) == null ? void 0 : i.code) || "LOGIN_BY_CODE_FAILED",
        400,
        (n = a.error) == null ? void 0 : n.details
      );
    return a.data;
  } catch (a) {
    if (a instanceof R)
      throw a;
    return he(a);
  }
}
async function X(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.get("api/v1/users/me", {
      headers: {
        Authorization: `Bearer ${e}`
      },
      timeout: 1e4
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Failed to fetch user profile",
        ((o = n.error) == null ? void 0 : o.code) || "PROFILE_FETCH_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return he(n);
  }
}
async function At(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.post("api/v1/oauth/google/callback", {
      json: e
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Google OAuth failed",
        ((o = n.error) == null ? void 0 : o.code) || "GOOGLE_OAUTH_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return Qe(n, "Google");
  }
}
async function Br(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.post("api/v1/oauth/facebook/callback", {
      json: e
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Facebook OAuth failed",
        ((o = n.error) == null ? void 0 : o.code) || "FACEBOOK_OAUTH_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return Qe(n, "Facebook");
  }
}
async function Vr(e) {
  var r, o, i;
  const t = J();
  try {
    const n = await t.post("api/v1/oauth/telegram/callback", {
      json: e
    }).json();
    if (!n.success || !n.data)
      throw new R(
        ((r = n.error) == null ? void 0 : r.message) || "Telegram OAuth failed",
        ((o = n.error) == null ? void 0 : o.code) || "TELEGRAM_OAUTH_FAILED",
        400,
        (i = n.error) == null ? void 0 : i.details
      );
    return n.data;
  } catch (n) {
    if (n instanceof R)
      throw n;
    return Qe(n, "Telegram");
  }
}
async function Qe(e, t) {
  var o, i, n;
  const { HTTPError: r } = await import("ky");
  if (e instanceof r)
    try {
      const a = await e.response.json();
      throw new R(
        ((o = a.error) == null ? void 0 : o.message) || e.message,
        ((i = a.error) == null ? void 0 : i.code) || `${t.toUpperCase()}_OAUTH_ERROR`,
        e.response.status,
        (n = a.error) == null ? void 0 : n.details
      );
    } catch (a) {
      throw a instanceof R ? a : new R(
        e.message,
        `${t.toUpperCase()}_OAUTH_ERROR`,
        e.response.status
      );
    }
  throw e instanceof Error ? new R(e.message, "NETWORK_ERROR", 0) : new R("Unknown error", "UNKNOWN_ERROR", 0);
}
let te = null;
const ne = [];
function ei() {
  te = null, ne.length = 0;
}
async function Wr(e) {
  if (te)
    return te;
  const t = y.getState(), r = t.refreshToken;
  if (!r)
    throw t.logout(), ce(), e == null || e(), new R("No refresh token", "NO_REFRESH_TOKEN", 401);
  return te = (async () => {
    try {
      const o = await Ze(r);
      t.updateToken(o.accessToken, o.expiresIn, o.refreshToken);
      const i = o.accessToken;
      return ne.forEach(({ resolve: n }) => n(i)), ne.length = 0, i;
    } catch (o) {
      throw ne.forEach(({ reject: i }) => i(o)), ne.length = 0, o instanceof R && (o.status === 401 || o.status === 422) && (t.logout(), ce(), e == null || e()), o;
    } finally {
      te = null;
    }
  })(), te;
}
function Kr() {
  return new Promise((e, t) => {
    ne.push({ resolve: e, reject: t });
  });
}
function Tt(e = {}) {
  const { baseUrl: t, timeout: r = 3e4, onSessionExpired: o } = e;
  return Pe.create({
    prefixUrl: t,
    timeout: r,
    hooks: {
      beforeRequest: [
        async (i) => {
          if (te)
            try {
              const a = await Kr();
              i.headers.set("Authorization", `Bearer ${a}`);
              return;
            } catch {
            }
          const n = y.getState().token;
          n && i.headers.set("Authorization", `Bearer ${n}`);
        }
      ],
      afterResponse: [
        async (i, n, a) => {
          if (a.status !== 401 || i.url.includes("/auth/refresh") || i.url.includes("/auth/login"))
            return a;
          try {
            const l = await Wr(o), d = {
              ...n,
              headers: {
                ...Object.fromEntries(i.headers.entries()),
                Authorization: `Bearer ${l}`
              }
            };
            return Pe(i.url, d);
          } catch {
            return a;
          }
        }
      ]
    }
  });
}
let Le = null, Ct = {};
function ti(e) {
  Ct = e, Le = Tt(e);
}
function Jr() {
  return Le || (Le = Tt(Ct)), Le;
}
async function ri(e, t) {
  var o, i, n;
  const r = Jr();
  try {
    return await r(e, t).json();
  } catch (a) {
    if (a instanceof ut) {
      const l = await a.response.json().catch(() => ({}));
      throw new R(
        ((o = l.error) == null ? void 0 : o.message) || a.message,
        ((i = l.error) == null ? void 0 : i.code) || "HTTP_ERROR",
        a.response.status,
        (n = l.error) == null ? void 0 : n.details
      );
    }
    throw a;
  }
}
function St() {
  const e = y((h) => h.user), t = y((h) => h.token), r = y((h) => h.refreshToken), o = y((h) => h.isAuthenticated), i = y((h) => h.isLoading), n = y((h) => h.login), a = y((h) => h.logout), l = y((h) => h.updateToken), d = y((h) => h.updateUser), u = y((h) => h.setLoading), f = y((h) => h.hasRole), g = y((h) => h.hasAnyRole), b = y((h) => h.hasPermission), w = E(
    async (h) => {
      u(!0);
      try {
        const p = await Hr(h), { accessToken: v, refreshToken: C, expiresIn: A, user: S } = p, x = await X(v), O = Y({
          ...x,
          user_guid: x.user_guid || S.guid,
          email: x.email || S.email
        });
        return n(v, C, A, O), O;
      } catch (p) {
        throw u(!1), p;
      }
    },
    [n, u]
  ), T = E(
    async (h, p) => {
      u(!0);
      try {
        const v = await $r(h, p), { accessToken: C, refreshToken: A, expiresIn: S, user: x } = v, O = await X(C), z = Y({
          ...O,
          user_guid: O.user_guid || x.guid,
          email: O.email || x.email
        });
        return n(C, A, S, z), z;
      } catch (v) {
        throw u(!1), v;
      }
    },
    [n, u]
  ), c = E(
    async (h) => {
      u(!0);
      try {
        const p = await kt(h), { accessToken: v, refreshToken: C, expiresIn: A, user: S } = p, x = await X(v), O = Y({
          ...x,
          user_guid: x.user_guid || S.guid,
          email: x.email || S.email
        });
        return n(v, C, A, O), O;
      } catch (p) {
        throw u(!1), p;
      }
    },
    [n, u]
  ), m = E(async () => {
    if (!r)
      throw a(), ce(), new R("No refresh token available", "NO_REFRESH_TOKEN", 401);
    try {
      const h = await Ze(r);
      l(h.accessToken, h.expiresIn);
    } catch (h) {
      throw a(), ce(), h;
    }
  }, [r, a, l]), _ = E(async () => {
    r && Gr(r), a(), ce();
  }, [r, a]), k = E(async () => {
    if (!t)
      throw new R("Not authenticated", "NOT_AUTHENTICATED", 401);
    u(!0);
    try {
      const h = await X(t), p = Y(h);
      return d(p), u(!1), p;
    } catch (h) {
      throw u(!1), h;
    }
  }, [t, u, d]);
  return {
    // State
    user: e,
    token: t,
    isAuthenticated: o,
    isLoading: i,
    // Actions
    loginWithCredentials: w,
    loginByCode: T,
    registerUser: c,
    refreshToken: m,
    logout: _,
    fetchProfile: k,
    // Helpers
    hasRole: f,
    hasAnyRole: g,
    hasPermission: b
  };
}
function Yr() {
  const [e, t] = P(() => {
    var r, o;
    return ((o = (r = y.persist) == null ? void 0 : r.hasHydrated) == null ? void 0 : o.call(r)) ?? !1;
  });
  return H(() => {
    var o, i, n, a;
    if (e) return;
    const r = (i = (o = y.persist) == null ? void 0 : o.onFinishHydration) == null ? void 0 : i.call(o, () => {
      t(!0);
    });
    return (a = (n = y.persist) == null ? void 0 : n.hasHydrated) != null && a.call(n) && t(!0), () => {
      r == null || r();
    };
  }, [e]), e;
}
function Zr(e = {}) {
  const { requiredRoles: t = [], requiredPermissions: r = [], requireAllRoles: o = !1 } = e, i = Yr(), n = y((b) => b.user), a = y((b) => b.isAuthenticated), l = y((b) => b.isLoading), d = y((b) => b.hasRole), u = y((b) => b.hasPermission), f = !i || l;
  return {
    ...ve(() => {
      if (!a || !n)
        return {
          isAllowed: !1,
          isAuthenticated: !1,
          missingRoles: t,
          missingPermissions: r,
          denyReason: "not_authenticated"
        };
      let b = [], w = !0;
      t.length > 0 && (o ? (b = t.filter((m) => !d(m)), w = b.length === 0) : t.some((_) => d(_)) || (b = t, w = !1));
      const T = r.filter((m) => !u(m)), c = T.length === 0;
      return w ? c ? {
        isAllowed: !0,
        isAuthenticated: !0,
        missingRoles: [],
        missingPermissions: [],
        denyReason: "none"
      } : {
        isAllowed: !1,
        isAuthenticated: !0,
        missingRoles: [],
        missingPermissions: T,
        denyReason: "missing_permissions"
      } : {
        isAllowed: !1,
        isAuthenticated: !0,
        missingRoles: b,
        missingPermissions: T,
        denyReason: "missing_roles"
      };
    }, [
      a,
      n,
      t,
      r,
      o,
      d,
      u
    ]),
    isLoading: f,
    user: n
  };
}
const Qr = 5 * 60 * 1e3, Xr = 3, eo = 1e3;
let Q = null;
function oi() {
  return Q;
}
function ni() {
  Q = null;
}
function to(e = {}) {
  const {
    refreshThreshold: t = Qr,
    maxRetries: r = Xr,
    retryBaseDelay: o = eo,
    onRefreshError: i,
    onSessionExpired: n
  } = e, [a, l] = P(!1), [d, u] = P(null), [f, g] = P(0), [b, w] = P(null), T = $(null), c = $(null), m = $(!0), _ = y((I) => I.refreshToken), k = y((I) => I.expiresAt), h = y((I) => I.isAuthenticated), p = y((I) => I.updateToken), v = y((I) => I.logout), C = E(() => {
    T.current && (clearTimeout(T.current), T.current = null);
  }, []), A = E(() => {
    c.current && (clearInterval(c.current), c.current = null);
  }, []), S = E(
    async (I = 0) => {
      if (Q)
        return Q;
      if (!_)
        throw new R("No refresh token available", "NO_REFRESH_TOKEN", 401);
      return Q = (async () => {
        try {
          m.current && (l(!0), g(I));
          const q = await Ze(_);
          m.current && (p(q.accessToken, q.expiresIn, q.refreshToken), u(/* @__PURE__ */ new Date()), g(0));
        } catch (q) {
          const D = q instanceof R ? q : new R(
            q instanceof Error ? q.message : "Unknown error",
            "REFRESH_ERROR",
            0
          );
          if (D.status === 401 || D.status === 422)
            throw m.current && (v(), ce()), n == null || n(), D;
          if (D.code === "NETWORK_ERROR" && I < r) {
            const j = o * Math.pow(2, I);
            return await new Promise((U) => setTimeout(U, j)), Q = null, S(I + 1);
          }
          throw i == null || i(D), D;
        } finally {
          Q = null, m.current && l(!1);
        }
      })(), Q;
    },
    [_, p, v, r, o, i, n]
  ), x = E(() => {
    if (C(), !k || !h)
      return;
    const I = Date.now(), q = k - t - I;
    q <= 0 ? S().catch(() => {
    }) : T.current = setTimeout(() => {
      document.visibilityState === "visible" && S().catch(() => {
      });
    }, q);
  }, [k, h, t, C, S]), O = E(() => {
    if (document.visibilityState === "visible") {
      if (k && h) {
        const I = Date.now();
        k - I <= t ? S().catch(() => {
        }) : x();
      }
    } else
      C();
  }, [k, h, t, S, x, C]), z = E(async () => S(0), [S]);
  return H(() => {
    if (A(), !k || !h) {
      w(null);
      return;
    }
    const I = () => {
      const q = k - Date.now();
      w(q > 0 ? q : 0);
    };
    return I(), c.current = setInterval(I, 1e3), () => {
      A();
    };
  }, [k, h, A]), H(() => {
    x();
  }, [x]), H(() => (document.addEventListener("visibilitychange", O), () => {
    document.removeEventListener("visibilitychange", O);
  }), [O]), H(() => (m.current = !0, () => {
    m.current = !1, C(), A();
  }), [C, A]), {
    isRefreshing: a,
    lastRefresh: d,
    refresh: z,
    timeUntilExpiry: b,
    retryCount: f
  };
}
function ro(e = {}) {
  const { nonce: t, locale: r, onScriptLoadSuccess: o, onScriptLoadError: i } = e, [n, a] = P(!1), l = $(o);
  l.current = o;
  const d = $(i);
  return d.current = i, H(() => {
    const u = document.createElement("script");
    return u.src = "https://accounts.google.com/gsi/client", r && (u.src += `?hl=${r}`), u.async = !0, u.defer = !0, u.nonce = t, u.onload = () => {
      var f;
      a(!0), (f = l.current) === null || f === void 0 || f.call(l);
    }, u.onerror = () => {
      var f;
      a(!1), (f = d.current) === null || f === void 0 || f.call(d);
    }, document.body.appendChild(u), () => {
      document.body.removeChild(u);
    };
  }, [t]), n;
}
const Et = gt(null);
function oo({ clientId: e, nonce: t, locale: r, onScriptLoadSuccess: o, onScriptLoadError: i, children: n }) {
  const a = ro({
    nonce: t,
    onScriptLoadSuccess: o,
    onScriptLoadError: i,
    locale: r
  }), l = ve(() => ({
    locale: r,
    clientId: e,
    scriptLoadedSuccessfully: a
  }), [e, a]);
  return jt.createElement(Et.Provider, { value: l }, n);
}
function no() {
  const e = mt(Et);
  if (!e)
    throw new Error("Google OAuth components must be used within GoogleOAuthProvider");
  return e;
}
function io({ flow: e = "implicit", scope: t = "", onSuccess: r, onError: o, onNonOAuthError: i, overrideScope: n, state: a, ...l }) {
  const { clientId: d, scriptLoadedSuccessfully: u } = no(), f = $(), g = $(r);
  g.current = r;
  const b = $(o);
  b.current = o;
  const w = $(i);
  w.current = i, H(() => {
    var m, _;
    if (!u)
      return;
    const k = e === "implicit" ? "initTokenClient" : "initCodeClient", h = (_ = (m = window == null ? void 0 : window.google) === null || m === void 0 ? void 0 : m.accounts) === null || _ === void 0 ? void 0 : _.oauth2[k]({
      client_id: d,
      scope: n ? t : `openid profile email ${t}`,
      callback: (p) => {
        var v, C;
        if (p.error)
          return (v = b.current) === null || v === void 0 ? void 0 : v.call(b, p);
        (C = g.current) === null || C === void 0 || C.call(g, p);
      },
      error_callback: (p) => {
        var v;
        (v = w.current) === null || v === void 0 || v.call(w, p);
      },
      state: a,
      ...l
    });
    f.current = h;
  }, [d, u, e, t, a]);
  const T = E((m) => {
    var _;
    return (_ = f.current) === null || _ === void 0 ? void 0 : _.requestAccessToken(m);
  }, []), c = E(() => {
    var m;
    return (m = f.current) === null || m === void 0 ? void 0 : m.requestCode();
  }, []);
  return e === "implicit" ? T : c;
}
function ao(e = {}) {
  const { onSuccess: t, onError: r, redirectUri: o } = e, i = y((c) => c.login), n = y((c) => c.setLoading), [a, l] = P(!1), [d, u] = P(null), f = E(
    async (c) => {
      l(!0), n(!0), u(null);
      try {
        const m = await At({
          code: c.access_token,
          redirectUri: o || window.location.origin
        }), _ = await X(m.accessToken), k = Y({
          ..._,
          user_guid: _.user_guid || m.user.guid,
          email: _.email || m.user.email || void 0
        });
        i(
          m.accessToken,
          m.refreshToken,
          m.expiresIn,
          k
        ), t == null || t(m, k);
      } catch (m) {
        const _ = m instanceof Error ? m : new Error("Google authentication failed");
        u(_), n(!1), r == null || r(_);
      } finally {
        l(!1);
      }
    },
    [i, n, t, r, o]
  ), g = E(
    (c) => {
      const m = c.error_description || c.error || "Google login failed", _ = new Error(m);
      u(_), n(!1), r == null || r(_);
    },
    [n, r]
  ), b = E(
    (c) => {
      let m = "Google login failed";
      c.type === "popup_closed" ? m = "Login popup was closed" : c.type === "popup_failed_to_open" && (m = "Failed to open login popup. Please allow popups for this site.");
      const _ = new Error(m);
      u(_), r == null || r(_);
    },
    [r]
  ), w = io({
    onSuccess: f,
    onError: g,
    onNonOAuthError: b,
    flow: "implicit",
    scope: "email profile openid"
  });
  return {
    login: E(() => {
      u(null), w();
    }, [w]),
    isLoading: a,
    error: d
  };
}
function so(e) {
  const { appId: t, onSuccess: r, onError: o } = e, i = y((c) => c.login), n = y((c) => c.setLoading), [a, l] = P(!1), [d, u] = P(!1), [f, g] = P(null), b = $(!1);
  H(() => {
    if (window.FB) {
      u(!0);
      return;
    }
    if (b.current)
      return;
    if (document.getElementById("facebook-jssdk")) {
      b.current = !0;
      return;
    }
    b.current = !0, window.fbAsyncInit = () => {
      var m;
      (m = window.FB) == null || m.init({
        appId: t,
        version: "v18.0",
        cookie: !0,
        xfbml: !1
      }), u(!0);
    };
    const c = document.createElement("script");
    c.id = "facebook-jssdk", c.src = "https://connect.facebook.net/en_US/sdk.js", c.async = !0, c.defer = !0, document.body.appendChild(c);
  }, [t]);
  const w = E(
    async (c) => {
      if (c.status !== "connected" || !c.authResponse) {
        const m = new Error(
          c.status === "not_authorized" ? "Facebook login not authorized. Please grant permissions." : "Facebook login was cancelled or failed"
        );
        g(m), l(!1), n(!1), o == null || o(m);
        return;
      }
      try {
        const m = await Br({
          accessToken: c.authResponse.accessToken
        }), _ = await X(m.accessToken), k = Y({
          ..._,
          user_guid: _.user_guid || m.user.guid,
          email: _.email || m.user.email || void 0
        });
        i(
          m.accessToken,
          m.refreshToken,
          m.expiresIn,
          k
        ), r == null || r(m, k);
      } catch (m) {
        const _ = m instanceof Error ? m : new Error("Facebook authentication failed");
        g(_), n(!1), o == null || o(_);
      } finally {
        l(!1);
      }
    },
    [i, n, r, o]
  );
  return {
    login: E(() => {
      if (!d || !window.FB) {
        const c = new Error("Facebook SDK not ready. Please try again.");
        g(c), o == null || o(c);
        return;
      }
      l(!0), n(!0), g(null), window.FB.getLoginStatus((c) => {
        c.status === "connected" && c.authResponse ? w(c) : window.FB.login(
          (m) => {
            w(m);
          },
          {
            scope: "email,public_profile"
          }
        );
      });
    }, [d, w, n, o]),
    isLoading: a,
    isReady: d,
    error: f
  };
}
function lo(e) {
  const {
    botUsername: t,
    onSuccess: r,
    onError: o,
    size: i = "large",
    requestAccess: n = !1,
    showUserPic: a = !1
  } = e, l = y((p) => p.login), d = y((p) => p.setLoading), [u, f] = P(!1), [g, b] = P(!1), [w, T] = P(null), c = $(null), m = $(`telegramAuth_${Date.now()}`), _ = $(!1), k = $(void 0);
  H(() => {
    k.current = async (p) => {
      f(!0), d(!0), T(null);
      try {
        const v = await Vr(p), C = await X(v.accessToken), A = Y({
          ...C,
          user_guid: C.user_guid || v.user.guid,
          email: C.email || v.user.email || void 0
        });
        l(
          v.accessToken,
          v.refreshToken,
          v.expiresIn,
          A
        ), r == null || r(v, A);
      } catch (v) {
        const C = v instanceof Error ? v : new Error("Telegram authentication failed");
        T(C), d(!1), o == null || o(C);
      } finally {
        f(!1);
      }
    };
  }, [l, d, r, o]);
  const h = E((p) => {
    var v;
    (v = k.current) == null || v.call(k, p);
  }, []);
  return H(() => {
    if (!c.current || _.current) return;
    const p = c.current.querySelector('script[src*="telegram-widget"]'), v = c.current.querySelector("iframe");
    if (p || v) {
      _.current = !0;
      return;
    }
    _.current = !0;
    const C = m.current;
    window[C] = h, window.onTelegramAuth = h;
    const A = document.createElement("script");
    return A.src = "https://telegram.org/js/telegram-widget.js?22", A.async = !0, A.setAttribute("data-telegram-login", t), A.setAttribute("data-size", i), A.setAttribute("data-onauth", `${C}(user)`), A.setAttribute("data-userpic", a ? "true" : "false"), n && A.setAttribute("data-request-access", "write"), A.onload = () => {
      b(!0);
    }, A.onerror = () => {
      const S = new Error("Failed to load Telegram Login Widget");
      T(S), o == null || o(S);
    }, c.current.appendChild(A), () => {
      delete window[C], window.onTelegramAuth === h && delete window.onTelegramAuth, _.current = !1;
    };
  }, [t, i, n, a, h, o]), {
    containerRef: c,
    isLoading: u,
    isReady: g,
    error: w
  };
}
var st;
function Rt(e, t, r) {
  function o(l, d) {
    if (l._zod || Object.defineProperty(l, "_zod", {
      value: {
        def: d,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), l._zod.traits.has(e))
      return;
    l._zod.traits.add(e), t(l, d);
    const u = a.prototype, f = Object.keys(u);
    for (let g = 0; g < f.length; g++) {
      const b = f[g];
      b in l || (l[b] = u[b].bind(l));
    }
  }
  const i = (r == null ? void 0 : r.Parent) ?? Object;
  class n extends i {
  }
  Object.defineProperty(n, "name", { value: e });
  function a(l) {
    var d;
    const u = r != null && r.Parent ? new n() : this;
    o(u, l), (d = u._zod).deferred ?? (d.deferred = []);
    for (const f of u._zod.deferred)
      f();
    return u;
  }
  return Object.defineProperty(a, "init", { value: o }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (l) => {
      var d, u;
      return r != null && r.Parent && l instanceof r.Parent ? !0 : (u = (d = l == null ? void 0 : l._zod) == null ? void 0 : d.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class co extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
(st = globalThis).__zod_globalConfig ?? (st.__zod_globalConfig = {});
const uo = globalThis.__zod_globalConfig;
function mo(e) {
  return uo;
}
function go(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
const ho = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Ce(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function fo(e, t, r) {
  var d, u, f, g, b, w;
  const o = e.message ? e.message : Ce((f = (u = (d = e.inst) == null ? void 0 : d._zod.def) == null ? void 0 : u.error) == null ? void 0 : f.call(u, e)) ?? Ce((g = t == null ? void 0 : t.error) == null ? void 0 : g.call(t, e)) ?? Ce((b = r.customError) == null ? void 0 : b.call(r, e)) ?? Ce((w = r.localeError) == null ? void 0 : w.call(r, e)) ?? "Invalid input", { inst: i, continue: n, input: a, ...l } = e;
  return l.path ?? (l.path = []), l.message = o, t != null && t.reportInput && (l.input = a), l;
}
const It = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, go, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, po = Rt("$ZodError", It), _o = Rt("$ZodError", It, { Parent: Error }), wo = (e) => (t, r, o, i) => {
  const n = o ? { ...o, async: !1 } : { async: !1 }, a = t._zod.run({ value: r, issues: [] }, n);
  if (a instanceof Promise)
    throw new co();
  if (a.issues.length) {
    const l = new ((i == null ? void 0 : i.Err) ?? e)(a.issues.map((d) => fo(d, n, mo())));
    throw ho(l, i == null ? void 0 : i.callee), l;
  }
  return a.value;
}, bo = /* @__PURE__ */ wo(_o);
function Ve(e, t) {
  return (r) => {
    try {
      return bo(e, r), {};
    } catch (o) {
      if (o instanceof po) {
        const i = {};
        return o.issues.forEach((n) => {
          i[n.path.join(".")] = n.message;
        }), i;
      }
      throw o;
    }
  };
}
function yo({
  onSuccess: e,
  onError: t,
  label: r,
  iconOnly: o = !1,
  ...i
}) {
  const { t: n } = G("auth"), { login: a, isLoading: l } = ao({
    onSuccess: e,
    onError: t
  }), d = r ?? n("oauth.google.button", "Sign in with Google");
  return o ? /* @__PURE__ */ s(
    V,
    {
      onClick: a,
      loading: l,
      variant: "default",
      ...i,
      "aria-label": d,
      "data-testid": "google-login-button",
      children: /* @__PURE__ */ s(ot, { size: 18 })
    }
  ) : /* @__PURE__ */ s(
    V,
    {
      leftSection: /* @__PURE__ */ s(ot, { size: 18 }),
      onClick: a,
      loading: l,
      variant: "default",
      ...i,
      "aria-label": d,
      "data-testid": "google-login-button",
      children: d
    }
  );
}
function vo({
  appId: e,
  onSuccess: t,
  onError: r,
  label: o,
  iconOnly: i = !1,
  ...n
}) {
  const { t: a } = G("auth"), { login: l, isLoading: d, isReady: u } = so({
    appId: e,
    onSuccess: t,
    onError: r
  }), f = o ?? a("oauth.facebook.button", "Sign in with Facebook");
  return i ? /* @__PURE__ */ s(
    V,
    {
      onClick: l,
      loading: d,
      disabled: !u,
      variant: "default",
      ...n,
      "aria-label": f,
      "data-testid": "facebook-login-button",
      children: /* @__PURE__ */ s(nt, { size: 18 })
    }
  ) : /* @__PURE__ */ s(
    V,
    {
      leftSection: /* @__PURE__ */ s(nt, { size: 18 }),
      onClick: l,
      loading: d,
      disabled: !u,
      variant: "default",
      ...n,
      "aria-label": f,
      "data-testid": "facebook-login-button",
      children: f
    }
  );
}
function ko({
  botUsername: e,
  onSuccess: t,
  onError: r,
  size: o = "large",
  requestAccess: i = !1,
  showUserPic: n = !1,
  showLoader: a = !0,
  ...l
}) {
  const { t: d } = G("auth"), { containerRef: u, isLoading: f, error: g } = lo({
    botUsername: e,
    onSuccess: t,
    onError: r,
    size: o,
    requestAccess: i,
    showUserPic: n
  }), [b, w] = P(!1), [T, c] = P(!1);
  return H(() => {
    if (!u.current) return;
    const _ = new MutationObserver((k) => {
      var h;
      for (const p of k)
        p.type === "childList" && ((h = u.current) != null && h.querySelector("iframe")) && (w(!0), _.disconnect());
    });
    return _.observe(u.current, { childList: !0, subtree: !0 }), () => _.disconnect();
  }, [u]), H(() => {
    if (b || T) return;
    const _ = setTimeout(() => {
      c(!0);
    }, 1e4);
    return () => clearTimeout(_);
  }, [b, T]), /* @__PURE__ */ L(
    ke,
    {
      ...l,
      "data-testid": "telegram-login-button",
      style: {
        position: "relative",
        minHeight: o === "large" ? 40 : o === "medium" ? 32 : 24,
        ...l.style
      },
      children: [
        /* @__PURE__ */ s("div", { ref: u, style: { display: "flex", justifyContent: "center" } }),
        a && !b && !T && /* @__PURE__ */ L(re, { py: "sm", children: [
          /* @__PURE__ */ s(Oe, { size: "sm", mr: "xs" }),
          /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", children: d("oauth.telegram.loading", "Loading Telegram...") })
        ] }),
        T && !b && /* @__PURE__ */ s(de, { color: "yellow", variant: "light", py: "xs", children: /* @__PURE__ */ s(N, { size: "xs", c: "dimmed", ta: "center", children: d("oauth.telegram.load_timeout", "Telegram widget could not load. Try refreshing the page.") }) }),
        f && /* @__PURE__ */ s(
          ke,
          {
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)"
            },
            children: /* @__PURE__ */ s(Oe, { size: "sm" })
          }
        ),
        g && /* @__PURE__ */ s(N, { size: "xs", c: "red", mt: "xs", children: g.message })
      ]
    }
  );
}
function Lt({
  google: e = !0,
  facebook: t = !0,
  telegram: r = !0,
  googleClientId: o,
  facebookAppId: i,
  telegramBotUsername: n,
  onSuccess: a,
  onError: l,
  showDivider: d = !0,
  dividerText: u,
  layout: f = "vertical",
  ...g
}) {
  const { t: b } = G("auth");
  e && !o && console.warn("SocialLoginButtons: googleClientId is required when google=true"), t && !i && console.warn("SocialLoginButtons: facebookAppId is required when facebook=true"), r && !n && console.warn("SocialLoginButtons: telegramBotUsername is required when telegram=true");
  const w = (_) => (k, h) => {
    a == null || a(k, h, _);
  }, T = (_) => (k) => {
    l == null || l(k, _);
  };
  if ([e && o, t && i, r && n].filter(Boolean).length === 0)
    return null;
  const m = /* @__PURE__ */ L(ee, { children: [
    e && o && /* @__PURE__ */ s(oo, { clientId: o, children: /* @__PURE__ */ s(
      yo,
      {
        onSuccess: w("google"),
        onError: T("google"),
        fullWidth: f === "vertical"
      }
    ) }),
    t && i && /* @__PURE__ */ s(
      vo,
      {
        appId: i,
        onSuccess: w("facebook"),
        onError: T("facebook"),
        fullWidth: f === "vertical"
      }
    ),
    r && n && /* @__PURE__ */ s(
      ko,
      {
        botUsername: n,
        onSuccess: w("telegram"),
        onError: T("telegram")
      }
    )
  ] });
  return /* @__PURE__ */ L(F, { gap: "sm", ...g, "data-testid": "social-login-buttons", children: [
    d && /* @__PURE__ */ s(
      We,
      {
        label: /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", children: u || b("oauth.divider", "or") }),
        labelPosition: "center"
      }
    ),
    f === "vertical" ? /* @__PURE__ */ s(F, { gap: "xs", children: m }) : /* @__PURE__ */ s(oe, { gap: "xs", justify: "center", children: m })
  ] });
}
const Ao = W.object({
  email: W.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
  password: W.string().min(1, "login.errors.password_required")
}), To = W.object({
  email: W.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
  code: W.string().min(6, "login.errors.code_invalid").max(6, "login.errors.code_invalid")
});
function Pt({
  onSuccess: e,
  onError: t,
  disabled: r = !1,
  showSocialLogin: o = !0,
  googleClientId: i,
  facebookAppId: n,
  telegramBotUsername: a,
  onSocialSuccess: l,
  onSocialError: d,
  showCodeLogin: u = !0,
  defaultMethod: f = "password"
}) {
  const { t: g } = G("auth"), { loginWithCredentials: b, loginByCode: w, isLoading: T } = St(), [c, m] = P(null), [_, k] = P(f), [h, p] = P(!1), [v, C] = P(!1), A = $e({
    initialValues: { email: "", password: "" },
    validate: Ve(Ao)
  }), S = $e({
    initialValues: { email: "", code: "" },
    validate: Ve(To)
  });
  H(() => {
    _ === "code" ? S.setFieldValue("email", A.values.email) : A.setFieldValue("email", S.values.email), m(null);
  }, [_]);
  const x = E(
    async (j) => {
      m(null);
      try {
        const U = await b({
          email: j.email,
          password: j.password
        });
        e == null || e(U);
      } catch (U) {
        const M = Co(U, g);
        m(M), t == null || t(U instanceof Error ? U : new Error(M));
      }
    },
    [b, e, t, g]
  ), O = E(async () => {
    if (!S.validateField("email").hasError) {
      m(null), C(!0);
      try {
        await jr(S.values.email), p(!0);
      } catch (U) {
        const M = lt(U, g);
        m(M);
      } finally {
        C(!1);
      }
    }
  }, [S, g]), z = E(
    async (j) => {
      m(null);
      try {
        const U = await w(j.email, j.code);
        e == null || e(U);
      } catch (U) {
        const M = lt(U, g);
        m(M), t == null || t(U instanceof Error ? U : new Error(M));
      }
    },
    [w, e, t, g]
  ), I = E(() => {
    p(!1), S.setFieldValue("code", ""), m(null);
  }, [S]), q = E(
    (j, U, M) => {
      e == null || e(U), l == null || l(j, M);
    },
    [e, l]
  ), D = T || r;
  return /* @__PURE__ */ L(F, { gap: "md", children: [
    o && /* @__PURE__ */ L(ee, { children: [
      /* @__PURE__ */ s(
        Lt,
        {
          googleClientId: i,
          facebookAppId: n,
          telegramBotUsername: a,
          onSuccess: q,
          onError: d,
          showDivider: !1
        }
      ),
      /* @__PURE__ */ s(
        We,
        {
          label: /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", children: g("login.or_with_email") }),
          labelPosition: "center"
        }
      )
    ] }),
    c && /* @__PURE__ */ s(
      de,
      {
        icon: /* @__PURE__ */ s(Ne, { size: 16 }),
        color: "red",
        variant: "light",
        title: g("login.error_title"),
        "aria-live": "polite",
        "data-testid": "login-error",
        children: c
      }
    ),
    u && /* @__PURE__ */ s(
      $t,
      {
        value: _,
        onChange: (j) => k(j),
        data: [
          { label: g("login.method_password"), value: "password" },
          { label: g("login.method_code"), value: "code" }
        ],
        fullWidth: !0,
        "data-testid": "login-method-toggle"
      }
    ),
    _ === "password" && /* @__PURE__ */ s("form", { onSubmit: A.onSubmit(x), noValidate: !0, children: /* @__PURE__ */ L(F, { gap: "md", children: [
      /* @__PURE__ */ s(
        pe,
        {
          label: g("login.email_label"),
          placeholder: g("login.email_placeholder"),
          leftSection: /* @__PURE__ */ s(xe, { size: 16 }),
          autoComplete: "email",
          type: "email",
          inputMode: "email",
          "data-autofocus": !0,
          "data-testid": "login-email",
          "aria-label": g("login.email_label"),
          "aria-required": "true",
          "aria-invalid": !!A.errors.email,
          disabled: D,
          ...A.getInputProps("email"),
          error: A.errors.email ? g(A.errors.email) : void 0
        }
      ),
      /* @__PURE__ */ s(
        je,
        {
          label: g("login.password_label"),
          placeholder: g("login.password_placeholder"),
          leftSection: /* @__PURE__ */ s(ze, { size: 16 }),
          autoComplete: "current-password",
          "data-testid": "login-password",
          "aria-label": g("login.password_label"),
          "aria-required": "true",
          "aria-invalid": !!A.errors.password,
          disabled: D,
          ...A.getInputProps("password"),
          error: A.errors.password ? g(A.errors.password) : void 0
        }
      ),
      /* @__PURE__ */ s(
        V,
        {
          type: "submit",
          fullWidth: !0,
          loading: T,
          disabled: r,
          "data-testid": "login-submit",
          mt: "xs",
          children: g("login.submit")
        }
      )
    ] }) }),
    _ === "code" && /* @__PURE__ */ s("form", { onSubmit: S.onSubmit(z), noValidate: !0, children: /* @__PURE__ */ L(F, { gap: "md", children: [
      /* @__PURE__ */ s(
        pe,
        {
          label: g("login.email_label"),
          placeholder: g("login.email_placeholder"),
          leftSection: /* @__PURE__ */ s(xe, { size: 16 }),
          autoComplete: "email",
          type: "email",
          inputMode: "email",
          "data-autofocus": !0,
          "data-testid": "login-email",
          "aria-label": g("login.email_label"),
          "aria-required": "true",
          "aria-invalid": !!S.errors.email,
          disabled: D || h,
          ...S.getInputProps("email"),
          error: S.errors.email ? g(S.errors.email) : void 0
        }
      ),
      h ? /* @__PURE__ */ L(ee, { children: [
        /* @__PURE__ */ s(N, { size: "sm", c: "teal", "data-testid": "login-code-sent-msg", children: g("login.code_sent") }),
        /* @__PURE__ */ s(
          pe,
          {
            label: g("login.code"),
            placeholder: "000000",
            leftSection: /* @__PURE__ */ s(Zt, { size: 16 }),
            autoComplete: "one-time-code",
            inputMode: "numeric",
            maxLength: 6,
            "data-testid": "login-code",
            "aria-label": g("login.code"),
            "aria-required": "true",
            "aria-invalid": !!S.errors.code,
            disabled: D,
            ...S.getInputProps("code"),
            error: S.errors.code ? g(S.errors.code) : void 0
          }
        ),
        /* @__PURE__ */ s(
          V,
          {
            type: "submit",
            fullWidth: !0,
            loading: T,
            disabled: r,
            "data-testid": "login-submit",
            mt: "xs",
            children: g("login.verify_and_sign_in")
          }
        ),
        /* @__PURE__ */ s(
          _e,
          {
            component: "button",
            type: "button",
            size: "sm",
            ta: "center",
            onClick: I,
            "data-testid": "login-resend-code",
            children: g("login.resend_code")
          }
        )
      ] }) : /* @__PURE__ */ s(
        V,
        {
          fullWidth: !0,
          variant: "light",
          loading: v,
          disabled: r,
          onClick: O,
          "data-testid": "login-send-code",
          mt: "xs",
          children: g("login.send_code")
        }
      )
    ] }) })
  ] });
}
function Co(e, t) {
  if (e instanceof R)
    switch (e.code) {
      case "INVALID_CREDENTIALS":
        return t("login.errors.invalid_credentials");
      case "ACCOUNT_LOCKED":
        return t("login.errors.account_locked");
      case "ACCOUNT_DISABLED":
        return t("login.errors.account_disabled");
      case "EMAIL_NOT_VERIFIED":
        return t("login.errors.email_not_verified");
      default:
        return e.message || t("login.errors.generic");
    }
  return e instanceof Error && e.message || t("login.errors.generic");
}
function lt(e, t) {
  var r;
  if (e instanceof R)
    switch (e.code) {
      case "CODE_EXPIRED":
        return t("login.errors.code_expired");
      case "RATE_LIMITED":
        return t("login.errors.code_rate_limited");
      case "INVALID_CODE": {
        const o = (r = e.details) == null ? void 0 : r.remaining;
        return o !== void 0 ? t("login.errors.code_invalid_value", { remaining: o }) : t("login.errors.code_invalid_value", { remaining: "?" });
      }
      default:
        return e.message || t("login.errors.code_send_failed");
    }
  return e instanceof Error && e.message || t("login.errors.code_send_failed");
}
function ii({
  opened: e,
  onClose: t,
  onSuccess: r,
  onError: o,
  title: i,
  subtitle: n,
  closeOnSuccess: a = !0,
  size: l = "sm",
  centered: d = !0,
  showSocialLogin: u = !1,
  showCodeLogin: f,
  defaultMethod: g,
  googleClientId: b,
  facebookAppId: w,
  telegramBotUsername: T
}) {
  const { t: c } = G("auth"), m = E(
    (_) => {
      r == null || r(_), a && t();
    },
    [r, t, a]
  );
  return /* @__PURE__ */ s(
    Ke,
    {
      opened: e,
      onClose: t,
      title: i || c("login.modal_title"),
      size: l,
      centered: d,
      trapFocus: !0,
      closeOnEscape: !0,
      closeOnClickOutside: !0,
      "aria-labelledby": "login-modal-title",
      "data-testid": "login-modal",
      children: /* @__PURE__ */ L(F, { gap: "md", children: [
        n && /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", ta: "center", children: n }),
        /* @__PURE__ */ s(
          Pt,
          {
            onSuccess: m,
            onError: o,
            showSocialLogin: u,
            showCodeLogin: f,
            defaultMethod: g,
            googleClientId: b,
            facebookAppId: w,
            telegramBotUsername: T
          }
        )
      ] })
    }
  );
}
function ai({
  onSuccess: e,
  onError: t,
  redirectOnSuccess: r,
  logo: o,
  backgroundImage: i,
  title: n,
  subtitle: a,
  maxWidth: l = 420,
  showSocialLogin: d = !1,
  showCodeLogin: u,
  defaultMethod: f,
  googleClientId: g,
  facebookAppId: b,
  telegramBotUsername: w
}) {
  const { t: T } = G("auth"), c = Bt(), _ = Vt("light") === "dark", k = E(
    (p) => {
      e == null || e(p), r && typeof window < "u" && (window.location.href = r);
    },
    [e, r]
  ), h = i ? {
    backgroundImage: `url(${i})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : {};
  return /* @__PURE__ */ s(
    re,
    {
      mih: "100vh",
      style: {
        ...h,
        backgroundColor: i ? void 0 : _ ? c.colors.dark[8] : c.colors.gray[0]
      },
      "data-testid": "login-page",
      children: /* @__PURE__ */ s(ke, { w: { base: "100%", sm: l }, px: "md", py: "xl", children: /* @__PURE__ */ L(F, { gap: "lg", align: "center", children: [
        o && /* @__PURE__ */ s(ke, { mb: "md", "data-testid": "login-page-logo", children: o }),
        /* @__PURE__ */ s(
          Wt,
          {
            p: "xl",
            shadow: "md",
            radius: "md",
            withBorder: !0,
            w: "100%",
            style: i ? {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(10px)"
            } : void 0,
            children: /* @__PURE__ */ L(F, { gap: "md", children: [
              /* @__PURE__ */ s(
                ht,
                {
                  order: 2,
                  ta: "center",
                  "data-testid": "login-page-title",
                  children: n || T("login.page_title")
                }
              ),
              (a || !n) && /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", ta: "center", children: a || T("login.page_subtitle") }),
              /* @__PURE__ */ s(
                Pt,
                {
                  onSuccess: k,
                  onError: t,
                  showSocialLogin: d,
                  showCodeLogin: u,
                  defaultMethod: f,
                  googleClientId: g,
                  facebookAppId: b,
                  telegramBotUsername: w
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s(N, { size: "xs", c: "dimmed", ta: "center", children: T("login.help_text") })
      ] }) })
    }
  );
}
function Xe(e) {
  return [
    {
      key: "length",
      label: "password.requirements.length",
      met: e.length >= 8
    },
    {
      key: "uppercase",
      label: "password.requirements.uppercase",
      met: /[A-Z]/.test(e)
    },
    {
      key: "lowercase",
      label: "password.requirements.lowercase",
      met: /[a-z]/.test(e)
    },
    {
      key: "number",
      label: "password.requirements.number",
      met: /[0-9]/.test(e)
    }
  ];
}
function So(e) {
  if (!e) return 0;
  const t = Xe(e), o = t.filter((l) => l.met).length / t.length * 80, n = /[!@#$%^&*(),.?":{}|<>]/.test(e) ? 10 : 0, a = Math.min(10, Math.max(0, e.length - 8));
  return Math.min(100, o + n + a);
}
function Eo(e) {
  return e < 30 ? "red" : e < 60 ? "yellow" : e < 80 ? "lime" : "green";
}
function Ro(e) {
  return e < 30 ? "password.strength.weak" : e < 60 ? "password.strength.fair" : e < 80 ? "password.strength.good" : "password.strength.strong";
}
function Io({ met: e, label: t }) {
  const { t: r } = G("auth");
  return /* @__PURE__ */ L(oe, { gap: "xs", wrap: "nowrap", children: [
    /* @__PURE__ */ s(
      Je,
      {
        size: "xs",
        radius: "xl",
        color: e ? "green" : "red",
        variant: "light",
        children: e ? /* @__PURE__ */ s(ft, { size: 10 }) : /* @__PURE__ */ s(Qt, { size: 10 })
      }
    ),
    /* @__PURE__ */ s(
      N,
      {
        size: "xs",
        c: e ? "dimmed" : void 0,
        style: { textDecoration: e ? "line-through" : void 0 },
        children: r(t)
      }
    )
  ] });
}
function Lo({
  password: e,
  showRequirements: t = !0,
  compact: r = !1
}) {
  const { t: o } = G("auth"), i = ve(() => So(e), [e]), n = ve(() => Xe(e), [e]), a = Eo(i), l = Ro(i);
  return e ? r ? /* @__PURE__ */ s(
    rt,
    {
      value: i,
      color: a,
      size: "xs",
      "aria-label": o("password.strength.label"),
      "aria-valuenow": i,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }
  ) : /* @__PURE__ */ L(F, { gap: "xs", "data-testid": "password-strength-indicator", children: [
    /* @__PURE__ */ L(oe, { justify: "space-between", gap: "xs", children: [
      /* @__PURE__ */ s(N, { size: "xs", c: "dimmed", children: o("password.strength.label") }),
      /* @__PURE__ */ s(N, { size: "xs", c: a, fw: 500, children: o(l) })
    ] }),
    /* @__PURE__ */ s(
      rt,
      {
        value: i,
        color: a,
        size: "sm",
        "aria-label": o("password.strength.label"),
        "aria-valuenow": i,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "data-testid": "password-strength-progress"
      }
    ),
    t && /* @__PURE__ */ s(ke, { mt: "xs", children: /* @__PURE__ */ s(F, { gap: 4, children: n.map((d) => /* @__PURE__ */ s(Io, { met: d.met, label: d.label }, d.key)) }) })
  ] }) : null;
}
const Po = W.object({
  name: W.string().min(1, "register.errors.name_required").max(100, "register.errors.name_too_long"),
  email: W.string().min(1, "register.errors.email_required").email("register.errors.email_invalid"),
  password: W.string().min(8, "register.errors.password_min_length").refine((e) => /[A-Z]/.test(e), "register.errors.password_uppercase").refine((e) => /[a-z]/.test(e), "register.errors.password_lowercase").refine((e) => /[0-9]/.test(e), "register.errors.password_number"),
  confirmPassword: W.string().min(1, "register.errors.confirm_password_required"),
  acceptTerms: W.boolean().refine((e) => e === !0, "register.errors.terms_required")
}).refine((e) => e.password === e.confirmPassword, {
  message: "register.errors.passwords_mismatch",
  path: ["confirmPassword"]
});
function Oo({
  onSuccess: e,
  onError: t,
  showLogin: r = !1,
  onLoginClick: o,
  termsUrl: i = "/terms",
  privacyUrl: n = "/privacy",
  submitLabel: a,
  disabled: l = !1,
  showPasswordStrength: d = !0,
  showSocialLogin: u = !1,
  googleClientId: f,
  facebookAppId: g,
  telegramBotUsername: b,
  onSocialSuccess: w,
  onSocialError: T
}) {
  const { t: c } = G("auth"), [m, _] = P(!1), [k, h] = P(null), p = $e({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      acceptTerms: !1
    },
    validate: Ve(Po)
  }), v = E((O) => Xe(O).every((I) => I.met), []), C = E(
    async (O) => {
      h(null), _(!0);
      try {
        await kt({
          email: O.email,
          password: O.password,
          firstName: O.name.split(" ")[0],
          lastName: O.name.split(" ").slice(1).join(" ") || void 0
        }), e == null || e();
      } catch (z) {
        let I;
        if (z instanceof R)
          switch (z.code) {
            case "EMAIL_EXISTS":
            case "USER_EXISTS":
              I = c("register.errors.email_exists");
              break;
            case "VALIDATION_ERROR":
              I = c("register.errors.validation_error");
              break;
            case "RATE_LIMITED":
              I = c("register.errors.rate_limited");
              break;
            default:
              I = z.message || c("register.errors.generic");
          }
        else z instanceof Error ? I = z.message || c("register.errors.generic") : I = c("register.errors.generic");
        h(I), t == null || t(z instanceof Error ? z : new Error(I));
      } finally {
        _(!1);
      }
    },
    [e, t, c]
  ), A = m || l, S = p.values.password && !v(p.values.password), x = E(
    (O, z, I) => {
      e == null || e(z), w == null || w(O, I);
    },
    [e, w]
  );
  return /* @__PURE__ */ s("form", { onSubmit: p.onSubmit(C), noValidate: !0, children: /* @__PURE__ */ L(F, { gap: "md", children: [
    u && /* @__PURE__ */ L(ee, { children: [
      /* @__PURE__ */ s(
        Lt,
        {
          googleClientId: f,
          facebookAppId: g,
          telegramBotUsername: b,
          onSuccess: x,
          onError: T,
          showDivider: !1
        }
      ),
      /* @__PURE__ */ s(
        We,
        {
          label: /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", children: c("register.or_email", "or with email") }),
          labelPosition: "center"
        }
      )
    ] }),
    k && /* @__PURE__ */ s(
      de,
      {
        icon: /* @__PURE__ */ s(Ne, { size: 16 }),
        color: "red",
        variant: "light",
        title: c("register.error_title"),
        "aria-live": "polite",
        "data-testid": "register-error",
        children: k
      }
    ),
    /* @__PURE__ */ s(
      pe,
      {
        label: c("register.name_label"),
        placeholder: c("register.name_placeholder"),
        leftSection: /* @__PURE__ */ s(pt, { size: 16 }),
        autoComplete: "name",
        "data-autofocus": !0,
        "data-testid": "register-name",
        "aria-label": c("register.name_label"),
        "aria-required": "true",
        "aria-invalid": !!p.errors.name,
        disabled: A,
        ...p.getInputProps("name"),
        error: p.errors.name ? c(p.errors.name) : void 0
      }
    ),
    /* @__PURE__ */ s(
      pe,
      {
        label: c("register.email_label"),
        placeholder: c("register.email_placeholder"),
        leftSection: /* @__PURE__ */ s(xe, { size: 16 }),
        autoComplete: "email",
        type: "email",
        inputMode: "email",
        "data-testid": "register-email",
        "aria-label": c("register.email_label"),
        "aria-required": "true",
        "aria-invalid": !!p.errors.email,
        disabled: A,
        ...p.getInputProps("email"),
        error: p.errors.email ? c(p.errors.email) : void 0
      }
    ),
    /* @__PURE__ */ L(F, { gap: "xs", children: [
      /* @__PURE__ */ s(
        je,
        {
          label: c("register.password_label"),
          placeholder: c("register.password_placeholder"),
          leftSection: /* @__PURE__ */ s(ze, { size: 16 }),
          autoComplete: "new-password",
          "data-testid": "register-password",
          "aria-label": c("register.password_label"),
          "aria-required": "true",
          "aria-invalid": !!p.errors.password,
          "aria-describedby": "password-requirements",
          disabled: A,
          ...p.getInputProps("password"),
          error: p.errors.password ? c(p.errors.password) : void 0
        }
      ),
      d && /* @__PURE__ */ s("div", { id: "password-requirements", children: /* @__PURE__ */ s(
        Lo,
        {
          password: p.values.password,
          showRequirements: !0
        }
      ) })
    ] }),
    /* @__PURE__ */ s(
      je,
      {
        label: c("register.confirm_password_label"),
        placeholder: c("register.confirm_password_placeholder"),
        leftSection: /* @__PURE__ */ s(ze, { size: 16 }),
        autoComplete: "new-password",
        "data-testid": "register-confirm-password",
        "aria-label": c("register.confirm_password_label"),
        "aria-required": "true",
        "aria-invalid": !!p.errors.confirmPassword,
        disabled: A,
        ...p.getInputProps("confirmPassword"),
        error: p.errors.confirmPassword ? c(p.errors.confirmPassword) : void 0
      }
    ),
    /* @__PURE__ */ s(
      Kt,
      {
        label: /* @__PURE__ */ L(ee, { children: [
          c("register.terms_prefix"),
          " ",
          /* @__PURE__ */ s(_e, { href: i, target: "_blank", size: "sm", children: c("register.terms_link") }),
          " ",
          c("register.terms_and"),
          " ",
          /* @__PURE__ */ s(_e, { href: n, target: "_blank", size: "sm", children: c("register.privacy_link") })
        ] }),
        "data-testid": "register-terms",
        "aria-required": "true",
        "aria-invalid": !!p.errors.acceptTerms,
        disabled: A,
        ...p.getInputProps("acceptTerms", { type: "checkbox" }),
        error: p.errors.acceptTerms ? c(p.errors.acceptTerms) : void 0
      }
    ),
    /* @__PURE__ */ s(
      V,
      {
        type: "submit",
        fullWidth: !0,
        loading: m,
        disabled: l || !!S,
        "data-testid": "register-submit",
        mt: "xs",
        children: a || c("register.submit")
      }
    ),
    r && /* @__PURE__ */ s(oe, { justify: "center", mt: "xs", children: /* @__PURE__ */ s(
      _e,
      {
        component: "button",
        type: "button",
        size: "sm",
        onClick: o,
        "data-testid": "register-login-link",
        children: c("register.have_account")
      }
    ) })
  ] }) });
}
function xo({
  email: e,
  onResendClick: t,
  onLoginClick: r,
  title: o,
  message: i
}) {
  const { t: n } = G("auth"), [a, l] = P(!1), [d, u] = P(!1), [f, g] = P(null), b = E(async () => {
    if (t) {
      l(!0), u(!1), g(null);
      try {
        await t(), u(!0);
      } catch (w) {
        g(
          w instanceof Error ? w.message : n("register.verification.resend_error")
        );
      } finally {
        l(!1);
      }
    }
  }, [t, n]);
  return /* @__PURE__ */ L(F, { gap: "lg", align: "center", "data-testid": "verification-success", children: [
    /* @__PURE__ */ s(re, { children: /* @__PURE__ */ s(
      Je,
      {
        size: 80,
        radius: 80,
        variant: "light",
        color: "green",
        "aria-hidden": "true",
        children: /* @__PURE__ */ s(xe, { size: 40 })
      }
    ) }),
    /* @__PURE__ */ L(F, { gap: "xs", align: "center", children: [
      /* @__PURE__ */ s(N, { size: "xl", fw: 600, ta: "center", children: o || n("register.verification.title") }),
      /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", ta: "center", maw: 400, children: i || n("register.verification.message", { email: e }) })
    ] }),
    d && /* @__PURE__ */ s(
      de,
      {
        icon: /* @__PURE__ */ s(ft, { size: 16 }),
        color: "green",
        variant: "light",
        w: "100%",
        "data-testid": "resend-success",
        children: n("register.verification.resend_success")
      }
    ),
    f && /* @__PURE__ */ s(
      de,
      {
        icon: /* @__PURE__ */ s(Ne, { size: 16 }),
        color: "red",
        variant: "light",
        w: "100%",
        "data-testid": "resend-error",
        children: f
      }
    ),
    /* @__PURE__ */ L(F, { gap: "md", w: "100%", children: [
      t && /* @__PURE__ */ s(
        V,
        {
          variant: "light",
          fullWidth: !0,
          loading: a,
          disabled: d,
          onClick: b,
          "data-testid": "resend-verification",
          children: n(d ? "register.verification.resend_sent" : "register.verification.resend_button")
        }
      ),
      r && /* @__PURE__ */ s(re, { children: /* @__PURE__ */ s(
        _e,
        {
          component: "button",
          type: "button",
          size: "sm",
          onClick: r,
          "data-testid": "back-to-login",
          children: n("register.verification.back_to_login")
        }
      ) })
    ] })
  ] });
}
function si({
  opened: e,
  onClose: t,
  onSuccess: r,
  onError: o,
  showLogin: i = !1,
  onLoginClick: n,
  termsUrl: a,
  privacyUrl: l,
  onResendVerification: d,
  title: u,
  subtitle: f,
  size: g = "sm",
  centered: b = !0,
  showSocialLogin: w = !1,
  googleClientId: T,
  facebookAppId: c,
  telegramBotUsername: m
}) {
  const { t: _ } = G("auth"), [k, h] = P(!1), [p, v] = P(""), C = E(() => {
    r == null || r(), h(!0);
  }, [r]), A = E(() => {
    n && n(), t();
  }, [n, t]), S = E(async () => {
    d && p && await d(p);
  }, [d, p]), x = E(() => {
    h(!1), v(""), t();
  }, [t]), O = E(() => {
    C();
  }, [C]);
  return /* @__PURE__ */ s(
    Ke,
    {
      opened: e,
      onClose: x,
      title: k ? _("register.verification.title") : u || _("register.modal_title"),
      size: g,
      centered: b,
      trapFocus: !0,
      closeOnEscape: !0,
      closeOnClickOutside: !k,
      "aria-labelledby": "register-modal-title",
      "data-testid": "register-modal",
      children: /* @__PURE__ */ L(F, { gap: "md", children: [
        !k && f && /* @__PURE__ */ s(N, { size: "sm", c: "dimmed", ta: "center", children: f }),
        k ? /* @__PURE__ */ s(
          xo,
          {
            email: p,
            onResendClick: d ? S : void 0,
            onLoginClick: A
          }
        ) : /* @__PURE__ */ s(
          zo,
          {
            onSuccess: O,
            onError: o,
            onEmailCapture: v,
            showLogin: i,
            onLoginClick: A,
            termsUrl: a,
            privacyUrl: l,
            showSocialLogin: w,
            googleClientId: T,
            facebookAppId: c,
            telegramBotUsername: m
          }
        )
      ] })
    }
  );
}
function zo({
  onSuccess: e,
  onError: t,
  onEmailCapture: r,
  ...o
}) {
  const i = E(
    (n) => {
      const a = n.currentTarget.querySelector("form");
      if (a) {
        const l = a.querySelector('[data-testid="register-email"]');
        l && r(l.value);
      }
    },
    [r]
  );
  return /* @__PURE__ */ s("div", { onSubmitCapture: i, children: /* @__PURE__ */ s(
    Oo,
    {
      onSuccess: e,
      onError: t,
      ...o
    }
  ) });
}
function ct({
  title: e,
  message: t,
  showBackButton: r = !0,
  showHomeButton: o = !0,
  homeUrl: i = "/",
  onBack: n,
  onHome: a
}) {
  const { t: l } = G("auth"), d = () => {
    n ? n() : window.history.back();
  }, u = () => {
    a ? a() : window.location.href = i;
  };
  return /* @__PURE__ */ L(F, { align: "center", justify: "center", gap: "xl", mih: 400, p: "xl", children: [
    /* @__PURE__ */ s(Je, { size: 80, radius: "xl", variant: "light", color: "red", children: /* @__PURE__ */ s(ze, { size: 40 }) }),
    /* @__PURE__ */ L(F, { align: "center", gap: "xs", children: [
      /* @__PURE__ */ s(ht, { order: 2, ta: "center", children: e || l("guard.unauthorized_title", "Access Denied") }),
      /* @__PURE__ */ s(N, { c: "dimmed", ta: "center", maw: 400, children: t || l("guard.unauthorized_message", "You don't have permission to access this page.") })
    ] }),
    /* @__PURE__ */ L(oe, { gap: "md", children: [
      r && /* @__PURE__ */ s(
        V,
        {
          variant: "default",
          leftSection: /* @__PURE__ */ s(Xt, { size: 16 }),
          onClick: d,
          children: l("guard.go_back", "Go Back")
        }
      ),
      o && /* @__PURE__ */ s(
        V,
        {
          variant: "filled",
          leftSection: /* @__PURE__ */ s(er, { size: 16 }),
          onClick: u,
          children: l("guard.go_home", "Go Home")
        }
      )
    ] })
  ] });
}
function dt({
  message: e,
  minHeight: t = "100vh",
  size: r = "lg"
}) {
  const { t: o } = G("auth");
  return /* @__PURE__ */ s(re, { mih: t, children: /* @__PURE__ */ L(F, { align: "center", gap: "md", children: [
    /* @__PURE__ */ s(Oe, { size: r }),
    /* @__PURE__ */ s(N, { c: "dimmed", size: "sm", children: e || o("guard.loading", "Checking authentication...") })
  ] }) });
}
const Ot = "returnTo", Mo = 2e3;
function et(e) {
  if (!e || typeof e != "string" || e.length > Mo) return !1;
  try {
    if (e.startsWith("/"))
      return !e.startsWith("//");
    const t = new URL(e, window.location.origin), r = new URL(window.location.origin);
    if (t.origin !== r.origin) {
      const o = t.hostname;
      if (![".teletienda.ar", ".teletienda.local"].some(
        (a) => o.endsWith(a) || o === a.slice(1)
      )) return !1;
    }
    return !0;
  } catch {
    return !1;
  }
}
function No(e, t) {
  if (!t || !et(t))
    return e;
  try {
    const r = new URL(e, window.location.origin);
    return r.searchParams.set(Ot, t), r.origin === window.location.origin ? r.pathname + r.search : r.toString();
  } catch {
    return e;
  }
}
function li() {
  try {
    const t = new URLSearchParams(window.location.search).get(Ot);
    return t && et(t) ? t : null;
  } catch {
    return null;
  }
}
function Fo() {
  return window.location.pathname + window.location.search;
}
function qo(e) {
  const t = et(e) ? e : "/";
  window.location.href = t;
}
function Uo(e) {
  try {
    const t = new URL(e, window.location.origin), r = window.location;
    return t.pathname === r.pathname && t.search === r.search;
  } catch {
    return !1;
  }
}
function Do({
  children: e,
  redirectTo: t,
  preserveReturnUrl: r = !0,
  fallback: o,
  loadingComponent: i,
  onDenied: n,
  navigate: a,
  // UseAuthGuardOptions
  requiredRoles: l,
  requiredPermissions: d,
  requireAllRoles: u
}) {
  const {
    isAllowed: f,
    isLoading: g,
    isAuthenticated: b,
    denyReason: w,
    missingRoles: T,
    missingPermissions: c
  } = Zr({
    requiredRoles: l,
    requiredPermissions: d,
    requireAllRoles: u
  }), m = $(!1);
  return H(() => {
    if (!g) {
      if (f) {
        m.current = !1;
        return;
      }
      if (w !== "none" && n && n(w), w === "not_authenticated" && t) {
        if (m.current) return;
        const _ = r ? Fo() : void 0, k = No(t, _);
        if (Uo(k)) {
          console.warn("[AuthGuard] Redirect loop detected, skipping redirect");
          return;
        }
        m.current = !0, a ? a(k, { replace: !0 }) : qo(k);
      }
    }
  }, [g, f, b, w, t, r, n, a]), g ? i || /* @__PURE__ */ s(dt, {}) : f ? /* @__PURE__ */ s(ee, { children: e }) : b && w !== "not_authenticated" ? o || /* @__PURE__ */ s(
    ct,
    {
      missingRoles: T,
      missingPermissions: c
    }
  ) : t ? i || /* @__PURE__ */ s(dt, {}) : o || /* @__PURE__ */ s(ct, {});
}
function ci({
  children: e,
  element: t,
  ...r
}) {
  return /* @__PURE__ */ s(Do, { ...r, children: t || e });
}
function Ho({
  src: e,
  name: t,
  size: r = "md",
  radius: o = "xl",
  className: i
}) {
  return /* @__PURE__ */ s(
    Jt,
    {
      src: e,
      name: t,
      alt: t,
      size: r,
      radius: o,
      color: "initials",
      className: i
    }
  );
}
const Go = "_userButton_1mcpb_5", jo = "_userName_1mcpb_28", $o = "_chevron_1mcpb_32", Ge = {
  userButton: Go,
  userName: jo,
  chevron: $o
};
function di({
  showProfile: e = !0,
  showOrders: t = !1,
  showFinances: r = !1,
  profileHref: o = "/profile",
  ordersHref: i = "/orders",
  financesHref: n = "/finances",
  additionalItems: a = [],
  onLogout: l,
  confirmLogout: d = !1,
  logoutRedirect: u,
  avatarSrc: f,
  hideUserName: g = !1,
  children: b
}) {
  const { t: w } = G("auth"), { user: T, logout: c, isLoading: m } = St(), [_, k] = P(!1), [h, { open: p, close: v }] = ir(!1), [C, A] = P(!1), S = ar("(max-width: 768px)"), x = g || S, O = E(() => {
    d ? p() : z();
  }, [d, p]), z = E(async () => {
    A(!0);
    try {
      const M = u || "/";
      window.location.href = M, await c(), sr.show({
        title: w("userMenu.logout_success_title"),
        message: w("userMenu.logout_success_message"),
        color: "blue",
        autoClose: 3e3
      }), l == null || l();
    } finally {
      A(!1), v();
    }
  }, [c, l, u, v, w]), I = E(() => {
    z();
  }, [z]);
  if (!T)
    return null;
  const q = T.name || "", D = [];
  e && D.push({
    label: w("userMenu.profile"),
    icon: pt,
    href: o
  }), t && D.push({
    label: w("userMenu.orders"),
    icon: tr,
    href: i
  }), r && D.push({
    label: w("userMenu.finances"),
    icon: rr,
    href: n
  });
  const j = [...D, ...a], U = (M, fe) => {
    const Te = [];
    M.dividerBefore && Te.push(/* @__PURE__ */ s(Z.Divider, {}, `divider-before-${fe}`));
    const tt = M.icon, Ft = /* @__PURE__ */ s(
      Z.Item,
      {
        leftSection: tt ? /* @__PURE__ */ s(tt, { size: 16, stroke: 1.5 }) : void 0,
        onClick: M.onClick,
        component: M.href ? "a" : void 0,
        href: M.href,
        children: M.label
      },
      `item-${fe}`
    );
    return Te.push(Ft), M.dividerAfter && Te.push(/* @__PURE__ */ s(Z.Divider, {}, `divider-after-${fe}`)), Te;
  };
  return /* @__PURE__ */ L(ee, { children: [
    /* @__PURE__ */ L(
      Z,
      {
        width: 220,
        position: "bottom-end",
        transitionProps: { transition: "pop-top-right" },
        opened: _,
        onChange: k,
        withinPortal: !0,
        children: [
          /* @__PURE__ */ s(Z.Target, { children: /* @__PURE__ */ s(
            Yt,
            {
              className: Ge.userButton,
              "data-opened": _ || void 0,
              "aria-label": w("userMenu.menuLabel"),
              children: /* @__PURE__ */ L(oe, { gap: "xs", wrap: "nowrap", children: [
                /* @__PURE__ */ s(
                  Ho,
                  {
                    src: f,
                    name: q,
                    size: "sm"
                  }
                ),
                !x && /* @__PURE__ */ L(ee, { children: [
                  /* @__PURE__ */ s(N, { size: "sm", fw: 500, className: Ge.userName, lineClamp: 1, children: q }),
                  /* @__PURE__ */ s(
                    or,
                    {
                      size: 14,
                      stroke: 1.5,
                      className: Ge.chevron,
                      "data-opened": _ || void 0
                    }
                  )
                ] })
              ] })
            }
          ) }),
          /* @__PURE__ */ L(Z.Dropdown, { children: [
            j.map((M, fe) => U(M, fe)),
            j.length > 0 && /* @__PURE__ */ s(Z.Divider, {}),
            /* @__PURE__ */ s(
              Z.Item,
              {
                color: "red",
                leftSection: /* @__PURE__ */ s(nr, { size: 16, stroke: 1.5 }),
                onClick: O,
                disabled: m || C,
                children: w("userMenu.logout")
              }
            ),
            b
          ] })
        ]
      }
    ),
    /* @__PURE__ */ s(
      Ke,
      {
        opened: h,
        onClose: v,
        title: w("userMenu.logoutConfirmTitle"),
        centered: !0,
        size: "sm",
        children: /* @__PURE__ */ L(F, { gap: "md", children: [
          /* @__PURE__ */ s(N, { size: "sm", children: w("userMenu.logoutConfirmMessage") }),
          /* @__PURE__ */ L(oe, { justify: "flex-end", gap: "sm", children: [
            /* @__PURE__ */ s(V, { variant: "default", onClick: v, disabled: C, children: w("userMenu.cancel") }),
            /* @__PURE__ */ s(V, { color: "red", onClick: I, loading: C, children: w("userMenu.logout") })
          ] })
        ] })
      }
    )
  ] });
}
const xt = gt(null);
function ui() {
  const e = mt(xt);
  if (!e)
    throw new Error("useAuthContext must be used within AuthProvider");
  return e;
}
function mi({
  children: e,
  apiBaseUrl: t,
  apiTimeout: r = 3e4,
  enableCrossTabSync: o = !0,
  refreshThreshold: i,
  maxRetries: n,
  retryBaseDelay: a,
  onRefreshError: l,
  onSessionExpired: d
}) {
  const u = to({
    refreshThreshold: i,
    maxRetries: n,
    retryBaseDelay: a,
    onRefreshError: l,
    onSessionExpired: d
  });
  ve(() => {
    Rr({
      baseUrl: t,
      timeout: r,
      getToken: () => y.getState().token
    }), Ir(() => y.getState().token);
  }, [t, r]), H(() => {
    let g;
    return o && (g = Dr()), () => {
      g == null || g();
    };
  }, [o]);
  const f = {
    ...u,
    isInitialized: !0
  };
  return /* @__PURE__ */ s(xt.Provider, { value: f, children: e });
}
function gi({
  onSuccess: e,
  onError: t,
  defaultReturnUrl: r = "/"
}) {
  const { t: o } = G("auth"), [i, n] = P(null), [a, l] = P(!0), d = y((f) => f.login);
  H(() => {
    u();
  }, []);
  async function u() {
    try {
      const f = new URLSearchParams(window.location.search), g = f.get("code"), b = f.get("state"), w = f.get("error"), T = f.get("error_description");
      if (w) {
        const C = T || w;
        throw new Error(o("oauth.errors.provider_denied", { error: C }));
      }
      let c = {};
      if (b)
        try {
          c = JSON.parse(atob(b));
        } catch {
          console.warn("[AuthCallbackPage] Failed to parse OAuth state");
        }
      const m = c.provider || Bo(f), _ = c.returnUrl || r;
      if (!m)
        throw new Error(o("oauth.errors.unknown_provider"));
      if (!g)
        throw new Error(o("oauth.errors.missing_code"));
      const k = `${window.location.origin}/auth/callback`;
      let h;
      switch (m) {
        case "google":
          h = await At({ code: g, redirectUri: k });
          break;
        case "facebook":
          throw new Error(o("oauth.errors.facebook_no_redirect"));
        case "telegram":
          throw new Error(o("oauth.errors.telegram_no_redirect"));
        default:
          throw new Error(o("oauth.errors.unknown_provider"));
      }
      const p = await X(h.accessToken), v = Y({
        ...p,
        user_guid: p.user_guid || h.user.guid,
        email: p.email || h.user.email || void 0
      });
      d(
        h.accessToken,
        h.refreshToken,
        h.expiresIn,
        v
      ), e == null || e(_);
    } catch (f) {
      const g = f instanceof Error ? f.message : o("oauth.errors.generic");
      n(g), t == null || t(f instanceof Error ? f : new Error(g));
    } finally {
      l(!1);
    }
  }
  return a ? /* @__PURE__ */ s(re, { h: "100vh", children: /* @__PURE__ */ L(F, { align: "center", gap: "md", children: [
    /* @__PURE__ */ s(Oe, { size: "lg" }),
    /* @__PURE__ */ s(N, { c: "dimmed", children: o("oauth.processing") })
  ] }) }) : i ? /* @__PURE__ */ s(re, { h: "100vh", children: /* @__PURE__ */ s(
    de,
    {
      icon: /* @__PURE__ */ s(Ne, { size: 16 }),
      title: o("oauth.error_title"),
      color: "red",
      variant: "light",
      maw: 400,
      children: i
    }
  ) }) : null;
}
function Bo(e) {
  const t = e.get("scope");
  if (t != null && t.includes("google") || t != null && t.includes("openid"))
    return "google";
  const r = e.get("state");
  if (r)
    try {
      if (JSON.parse(atob(r)).provider === "facebook")
        return "facebook";
    } catch {
    }
  return e.has("authuser") ? "google" : null;
}
function zt(e) {
  try {
    const t = e.split(".");
    if (t.length !== 3)
      return null;
    const r = t[1], o = atob(r.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(o);
  } catch {
    return null;
  }
}
function Mt(e) {
  const t = zt(e);
  return t != null && t.exp ? new Date(t.exp * 1e3) : null;
}
function hi(e, t = 0) {
  const r = Mt(e);
  if (!r)
    return !0;
  const o = t * 1e3;
  return Date.now() >= r.getTime() - o;
}
function fi(e) {
  const t = zt(e);
  return (t == null ? void 0 : t.sub) ?? null;
}
function pi(e) {
  const t = Mt(e);
  if (!t)
    return 0;
  const r = t.getTime() - Date.now();
  return Math.max(0, Math.floor(r / 1e3));
}
const Vo = {
  modal_title: "Iniciar sesión",
  page_title: "Iniciar sesión",
  page_subtitle: "Ingresa con tu cuenta",
  email_label: "Correo electrónico",
  email_placeholder: "tu@email.com",
  password_label: "Contraseña",
  password_placeholder: "Tu contraseña",
  submit: "Iniciar sesión",
  remember_me: "Recordarme",
  forgot_password: "¿Olvidaste tu contraseña?",
  no_account: "¿No tienes cuenta? Regístrate",
  error_title: "Error de autenticación",
  help_text: "¿Problemas para ingresar? Contacta al administrador.",
  success_title: "¡Bienvenido!",
  success_message: "Has iniciado sesión correctamente",
  or_with_email: "o con email",
  method_password: "Contraseña",
  method_code: "Código por email",
  send_code: "Enviar código de acceso",
  code: "Código de verificación",
  verify_and_sign_in: "Verificar e ingresar",
  resend_code: "Reenviar código",
  code_sent: "Código enviado a tu email",
  errors: {
    email_required: "El correo electrónico es requerido",
    email_invalid: "Correo electrónico inválido",
    password_required: "La contraseña es requerida",
    invalid_credentials: "Correo o contraseña incorrectos",
    account_locked: "Tu cuenta está bloqueada. Contacta al administrador.",
    account_disabled: "Tu cuenta está deshabilitada",
    email_not_verified: "Por favor verifica tu correo electrónico",
    generic: "Ocurrió un error. Intenta de nuevo.",
    code_invalid: "El código debe tener 6 dígitos",
    code_send_failed: "Error al enviar el código. Intenta de nuevo.",
    code_expired: "Código expirado. Solicita uno nuevo.",
    code_rate_limited: "Demasiados intentos. Espera 5 minutos.",
    code_invalid_value: "Código inválido. {{remaining}} intentos restantes."
  }
}, Wo = {
  modal_title: "Crear cuenta",
  page_title: "Registrarse",
  page_subtitle: "Crea tu cuenta",
  name_label: "Nombre completo",
  name_placeholder: "Juan Pérez",
  email_label: "Correo electrónico",
  email_placeholder: "tu@email.com",
  password_label: "Contraseña",
  password_placeholder: "Mínimo 8 caracteres",
  confirm_password_label: "Confirmar contraseña",
  confirm_password_placeholder: "Repite tu contraseña",
  terms_prefix: "Acepto los",
  terms_link: "Términos y Condiciones",
  terms_and: "y la",
  privacy_link: "Política de Privacidad",
  submit: "Crear cuenta",
  have_account: "¿Ya tienes cuenta? Inicia sesión",
  or_email: "o con email",
  error_title: "Error de registro",
  errors: {
    name_required: "El nombre es requerido",
    name_too_long: "El nombre es muy largo (máximo 100 caracteres)",
    email_required: "El correo electrónico es requerido",
    email_invalid: "Correo electrónico inválido",
    email_exists: "Ya existe una cuenta con este correo",
    password_min_length: "La contraseña debe tener al menos 8 caracteres",
    password_uppercase: "La contraseña debe contener al menos una mayúscula",
    password_lowercase: "La contraseña debe contener al menos una minúscula",
    password_number: "La contraseña debe contener al menos un número",
    confirm_password_required: "Confirma tu contraseña",
    passwords_mismatch: "Las contraseñas no coinciden",
    terms_required: "Debes aceptar los términos y condiciones",
    validation_error: "Error de validación. Revisa los campos.",
    rate_limited: "Demasiados intentos. Intenta más tarde.",
    generic: "Ocurrió un error. Intenta de nuevo."
  },
  verification: {
    title: "Verifica tu correo",
    message: "Hemos enviado un enlace de verificación a {{email}}. Por favor revisa tu bandeja de entrada.",
    resend_button: "Reenviar correo de verificación",
    resend_sent: "Correo enviado",
    resend_success: "Hemos reenviado el correo de verificación.",
    resend_error: "Error al reenviar. Intenta de nuevo.",
    back_to_login: "Volver a iniciar sesión"
  }
}, Ko = {
  strength: {
    label: "Fortaleza de contraseña",
    weak: "Débil",
    fair: "Regular",
    good: "Buena",
    strong: "Fuerte"
  },
  requirements: {
    length: "Mínimo 8 caracteres",
    uppercase: "Al menos una letra mayúscula",
    lowercase: "Al menos una letra minúscula",
    number: "Al menos un número"
  }
}, Jo = {
  loading: "Verificando autenticación...",
  unauthorized_title: "Acceso Denegado",
  unauthorized_message: "No tienes permiso para acceder a esta página.",
  go_back: "Volver",
  go_home: "Ir al Inicio"
}, Yo = {
  menuLabel: "Menú de usuario",
  profile: "Mi Perfil",
  orders: "Mis Pedidos",
  finances: "Mis Finanzas",
  logout: "Cerrar sesión",
  logoutConfirmTitle: "Cerrar sesión",
  logoutConfirmMessage: "¿Estás seguro de que quieres cerrar sesión?",
  cancel: "Cancelar",
  logout_success_title: "Sesión cerrada",
  logout_success_message: "Has cerrado sesión correctamente"
}, Zo = {
  title: "Iniciar sesión en TeleTienda",
  register_title: "Crear cuenta TeleTienda",
  continue_to: "para continuar a {{domain}}",
  redirecting: "Redirigiendo a {{domain}}...",
  code_error: "Error al completar la autenticación. Por favor, inténtalo de nuevo."
}, Qo = {
  divider: "o continuar con",
  processing: "Iniciando sesión...",
  error_title: "Error de autenticación",
  google: {
    button: "Iniciar sesión con Google",
    signup_button: "Registrarse con Google"
  },
  facebook: {
    button: "Iniciar sesión con Facebook",
    signup_button: "Registrarse con Facebook"
  },
  telegram: {
    button: "Iniciar sesión con Telegram",
    signup_button: "Registrarse con Telegram",
    loading: "Cargando Telegram...",
    load_timeout: "El widget de Telegram no pudo cargarse. Intenta recargar la página."
  },
  errors: {
    provider_denied: "Acceso denegado: {{error}}",
    unknown_provider: "Proveedor de autenticación desconocido",
    missing_code: "Código de autorización faltante",
    telegram_no_redirect: "Telegram no soporta flujo de redirección",
    popup_blocked: "La ventana emergente fue bloqueada. Permita ventanas emergentes e intente de nuevo.",
    network: "Error de red. Verifique su conexión.",
    generic: "Error de autenticación. Por favor, intente de nuevo."
  }
}, Xo = {
  login: Vo,
  register: Wo,
  password: Ko,
  guard: Jo,
  userMenu: Yo,
  portal: Zo,
  oauth: Qo
}, en = {
  modal_title: "Sign in",
  page_title: "Sign in",
  page_subtitle: "Log in to your account",
  email_label: "Email",
  email_placeholder: "your@email.com",
  password_label: "Password",
  password_placeholder: "Your password",
  submit: "Sign in",
  remember_me: "Remember me",
  forgot_password: "Forgot password?",
  no_account: "Don't have an account? Sign up",
  error_title: "Authentication error",
  help_text: "Having trouble signing in? Contact the administrator.",
  success_title: "Welcome!",
  success_message: "You have signed in successfully",
  or_with_email: "or with email",
  method_password: "Password",
  method_code: "Email Code",
  send_code: "Send login code",
  code: "Verification code",
  verify_and_sign_in: "Verify & Sign in",
  resend_code: "Resend code",
  code_sent: "Code sent to your email",
  errors: {
    email_required: "Email is required",
    email_invalid: "Invalid email address",
    password_required: "Password is required",
    invalid_credentials: "Invalid email or password",
    account_locked: "Your account is locked. Contact the administrator.",
    account_disabled: "Your account is disabled",
    email_not_verified: "Please verify your email address",
    generic: "An error occurred. Please try again.",
    code_invalid: "Code must be 6 digits",
    code_send_failed: "Failed to send code. Please try again.",
    code_expired: "Code expired. Please request a new one.",
    code_rate_limited: "Too many attempts. Please wait 5 minutes.",
    code_invalid_value: "Invalid code. {{remaining}} attempts remaining."
  }
}, tn = {
  modal_title: "Create account",
  page_title: "Sign up",
  page_subtitle: "Create your account",
  name_label: "Full name",
  name_placeholder: "John Doe",
  email_label: "Email",
  email_placeholder: "your@email.com",
  password_label: "Password",
  password_placeholder: "Minimum 8 characters",
  confirm_password_label: "Confirm password",
  confirm_password_placeholder: "Repeat your password",
  terms_prefix: "I accept the",
  terms_link: "Terms and Conditions",
  terms_and: "and the",
  privacy_link: "Privacy Policy",
  submit: "Create account",
  have_account: "Already have an account? Sign in",
  or_email: "or with email",
  error_title: "Registration error",
  errors: {
    name_required: "Name is required",
    name_too_long: "Name is too long (maximum 100 characters)",
    email_required: "Email is required",
    email_invalid: "Invalid email address",
    email_exists: "An account with this email already exists",
    password_min_length: "Password must be at least 8 characters",
    password_uppercase: "Password must contain at least one uppercase letter",
    password_lowercase: "Password must contain at least one lowercase letter",
    password_number: "Password must contain at least one number",
    confirm_password_required: "Please confirm your password",
    passwords_mismatch: "Passwords do not match",
    terms_required: "You must accept the terms and conditions",
    validation_error: "Validation error. Please check the fields.",
    rate_limited: "Too many attempts. Please try again later.",
    generic: "An error occurred. Please try again."
  },
  verification: {
    title: "Verify your email",
    message: "We've sent a verification link to {{email}}. Please check your inbox.",
    resend_button: "Resend verification email",
    resend_sent: "Email sent",
    resend_success: "We've resent the verification email.",
    resend_error: "Failed to resend. Please try again.",
    back_to_login: "Back to sign in"
  }
}, rn = {
  strength: {
    label: "Password strength",
    weak: "Weak",
    fair: "Fair",
    good: "Good",
    strong: "Strong"
  },
  requirements: {
    length: "Minimum 8 characters",
    uppercase: "At least one uppercase letter",
    lowercase: "At least one lowercase letter",
    number: "At least one number"
  }
}, on = {
  loading: "Checking authentication...",
  unauthorized_title: "Access Denied",
  unauthorized_message: "You don't have permission to access this page.",
  go_back: "Go Back",
  go_home: "Go Home"
}, nn = {
  menuLabel: "User menu",
  profile: "My Profile",
  orders: "My Orders",
  finances: "My Finances",
  logout: "Log out",
  logoutConfirmTitle: "Log out",
  logoutConfirmMessage: "Are you sure you want to log out?",
  cancel: "Cancel",
  logout_success_title: "Logged out",
  logout_success_message: "You have logged out successfully"
}, an = {
  title: "Sign in to TeleTienda",
  register_title: "Create TeleTienda Account",
  continue_to: "to continue to {{domain}}",
  redirecting: "Redirecting to {{domain}}...",
  code_error: "Failed to complete authentication. Please try again."
}, sn = {
  divider: "or continue with",
  processing: "Signing you in...",
  error_title: "Authentication Failed",
  google: {
    button: "Sign in with Google",
    signup_button: "Sign up with Google"
  },
  facebook: {
    button: "Sign in with Facebook",
    signup_button: "Sign up with Facebook"
  },
  telegram: {
    button: "Log in with Telegram",
    signup_button: "Sign up with Telegram",
    loading: "Loading Telegram...",
    load_timeout: "Telegram widget could not load. Try refreshing the page."
  },
  errors: {
    provider_denied: "Access was denied by {{error}}",
    unknown_provider: "Unknown authentication provider",
    missing_code: "Missing authorization code",
    telegram_no_redirect: "Telegram does not support redirect flow",
    popup_blocked: "Popup was blocked. Please allow popups and try again.",
    network: "Network error. Please check your connection.",
    generic: "Authentication failed. Please try again."
  }
}, ln = {
  login: en,
  register: tn,
  password: rn,
  guard: on,
  userMenu: nn,
  portal: an,
  oauth: sn
}, cn = {
  modal_title: "Вход",
  page_title: "Вход в систему",
  page_subtitle: "Войдите в свой аккаунт",
  email_label: "Электронная почта",
  email_placeholder: "ваш@email.com",
  password_label: "Пароль",
  password_placeholder: "Ваш пароль",
  submit: "Войти",
  remember_me: "Запомнить меня",
  forgot_password: "Забыли пароль?",
  no_account: "Нет аккаунта? Зарегистрируйтесь",
  error_title: "Ошибка авторизации",
  help_text: "Проблемы со входом? Свяжитесь с администратором.",
  success_title: "Добро пожаловать!",
  success_message: "Вы успешно вошли в систему",
  or_with_email: "или по email",
  method_password: "Пароль",
  method_code: "Код на email",
  send_code: "Отправить код входа",
  code: "Код подтверждения",
  verify_and_sign_in: "Подтвердить и войти",
  resend_code: "Отправить код ещё раз",
  code_sent: "Код отправлен на ваш email",
  errors: {
    email_required: "Email обязателен",
    email_invalid: "Неверный формат email",
    password_required: "Пароль обязателен",
    invalid_credentials: "Неверный email или пароль",
    account_locked: "Ваш аккаунт заблокирован. Свяжитесь с администратором.",
    account_disabled: "Ваш аккаунт отключен",
    email_not_verified: "Пожалуйста, подтвердите ваш email",
    generic: "Произошла ошибка. Попробуйте снова.",
    code_invalid: "Код должен содержать 6 цифр",
    code_send_failed: "Не удалось отправить код. Попробуйте снова.",
    code_expired: "Код истёк. Запросите новый.",
    code_rate_limited: "Слишком много попыток. Подождите 5 минут.",
    code_invalid_value: "Неверный код. Осталось попыток: {{remaining}}."
  }
}, dn = {
  modal_title: "Создать аккаунт",
  page_title: "Регистрация",
  page_subtitle: "Создайте свой аккаунт",
  name_label: "Полное имя",
  name_placeholder: "Иван Иванов",
  email_label: "Электронная почта",
  email_placeholder: "ваш@email.com",
  password_label: "Пароль",
  password_placeholder: "Минимум 8 символов",
  confirm_password_label: "Подтвердите пароль",
  confirm_password_placeholder: "Повторите пароль",
  terms_prefix: "Я принимаю",
  terms_link: "Условия использования",
  terms_and: "и",
  privacy_link: "Политику конфиденциальности",
  submit: "Создать аккаунт",
  have_account: "Уже есть аккаунт? Войти",
  or_email: "или по email",
  error_title: "Ошибка регистрации",
  errors: {
    name_required: "Имя обязательно",
    name_too_long: "Имя слишком длинное (максимум 100 символов)",
    email_required: "Email обязателен",
    email_invalid: "Неверный формат email",
    email_exists: "Аккаунт с таким email уже существует",
    password_min_length: "Пароль должен содержать минимум 8 символов",
    password_uppercase: "Пароль должен содержать хотя бы одну заглавную букву",
    password_lowercase: "Пароль должен содержать хотя бы одну строчную букву",
    password_number: "Пароль должен содержать хотя бы одну цифру",
    confirm_password_required: "Подтвердите пароль",
    passwords_mismatch: "Пароли не совпадают",
    terms_required: "Вы должны принять условия использования",
    validation_error: "Ошибка валидации. Проверьте поля.",
    rate_limited: "Слишком много попыток. Попробуйте позже.",
    generic: "Произошла ошибка. Попробуйте снова."
  },
  verification: {
    title: "Подтвердите email",
    message: "Мы отправили ссылку для подтверждения на {{email}}. Проверьте вашу почту.",
    resend_button: "Отправить письмо повторно",
    resend_sent: "Письмо отправлено",
    resend_success: "Мы повторно отправили письмо для подтверждения.",
    resend_error: "Не удалось отправить. Попробуйте снова.",
    back_to_login: "Вернуться к входу"
  }
}, un = {
  strength: {
    label: "Надежность пароля",
    weak: "Слабый",
    fair: "Средний",
    good: "Хороший",
    strong: "Надежный"
  },
  requirements: {
    length: "Минимум 8 символов",
    uppercase: "Хотя бы одна заглавная буква",
    lowercase: "Хотя бы одна строчная буква",
    number: "Хотя бы одна цифра"
  }
}, mn = {
  loading: "Проверка аутентификации...",
  unauthorized_title: "Доступ Запрещен",
  unauthorized_message: "У вас нет прав для доступа к этой странице.",
  go_back: "Назад",
  go_home: "На Главную"
}, gn = {
  menuLabel: "Меню пользователя",
  profile: "Мой Профиль",
  orders: "Мои Заказы",
  finances: "Мои Финансы",
  logout: "Выйти",
  logoutConfirmTitle: "Выход из системы",
  logoutConfirmMessage: "Вы уверены, что хотите выйти?",
  cancel: "Отмена",
  logout_success_title: "Вы вышли",
  logout_success_message: "Вы успешно вышли из системы"
}, hn = {
  title: "Вход в TeleTienda",
  register_title: "Создать аккаунт TeleTienda",
  continue_to: "для продолжения на {{domain}}",
  redirecting: "Перенаправление на {{domain}}...",
  code_error: "Не удалось завершить авторизацию. Пожалуйста, попробуйте снова."
}, fn = {
  divider: "или продолжить через",
  processing: "Выполняется вход...",
  error_title: "Ошибка аутентификации",
  google: {
    button: "Войти через Google",
    signup_button: "Зарегистрироваться через Google"
  },
  facebook: {
    button: "Войти через Facebook",
    signup_button: "Зарегистрироваться через Facebook"
  },
  telegram: {
    button: "Войти через Telegram",
    signup_button: "Зарегистрироваться через Telegram",
    loading: "Загрузка Telegram...",
    load_timeout: "Виджет Telegram не загрузился. Попробуйте обновить страницу."
  },
  errors: {
    provider_denied: "Доступ запрещен: {{error}}",
    unknown_provider: "Неизвестный провайдер аутентификации",
    missing_code: "Отсутствует код авторизации",
    telegram_no_redirect: "Telegram не поддерживает перенаправление",
    popup_blocked: "Всплывающее окно заблокировано. Разрешите всплывающие окна и попробуйте снова.",
    network: "Ошибка сети. Проверьте подключение.",
    generic: "Ошибка аутентификации. Попробуйте снова."
  }
}, pn = {
  login: cn,
  register: dn,
  password: un,
  guard: mn,
  userMenu: gn,
  portal: hn,
  oauth: fn
}, _n = {
  modal_title: "Entrar",
  page_title: "Entrar",
  page_subtitle: "Acesse sua conta",
  email_label: "E-mail",
  email_placeholder: "seu@email.com",
  password_label: "Senha",
  password_placeholder: "Sua senha",
  submit: "Entrar",
  remember_me: "Lembrar-me",
  forgot_password: "Esqueceu a senha?",
  no_account: "Não tem conta? Cadastre-se",
  error_title: "Erro de autenticação",
  help_text: "Problemas para entrar? Entre em contato com o administrador.",
  success_title: "Bem-vindo!",
  success_message: "Você entrou com sucesso",
  or_with_email: "ou com e-mail",
  method_password: "Senha",
  method_code: "Código por e-mail",
  send_code: "Enviar código de acesso",
  code: "Código de verificação",
  verify_and_sign_in: "Verificar e entrar",
  resend_code: "Reenviar código",
  code_sent: "Código enviado para seu e-mail",
  errors: {
    email_required: "O e-mail é obrigatório",
    email_invalid: "E-mail inválido",
    password_required: "A senha é obrigatória",
    invalid_credentials: "E-mail ou senha incorretos",
    account_locked: "Sua conta está bloqueada. Entre em contato com o administrador.",
    account_disabled: "Sua conta está desativada",
    email_not_verified: "Por favor, verifique seu e-mail",
    generic: "Ocorreu um erro. Tente novamente.",
    code_invalid: "O código deve ter 6 dígitos",
    code_send_failed: "Erro ao enviar o código. Tente novamente.",
    code_expired: "Código expirado. Solicite um novo.",
    code_rate_limited: "Muitas tentativas. Aguarde 5 minutos.",
    code_invalid_value: "Código inválido. {{remaining}} tentativas restantes."
  }
}, wn = {
  modal_title: "Criar conta",
  page_title: "Cadastrar",
  page_subtitle: "Crie sua conta",
  name_label: "Nome completo",
  name_placeholder: "João Silva",
  email_label: "E-mail",
  email_placeholder: "seu@email.com",
  password_label: "Senha",
  password_placeholder: "Mínimo 8 caracteres",
  confirm_password_label: "Confirmar senha",
  confirm_password_placeholder: "Repita sua senha",
  terms_prefix: "Eu aceito os",
  terms_link: "Termos e Condições",
  terms_and: "e a",
  privacy_link: "Política de Privacidade",
  submit: "Criar conta",
  have_account: "Já tem uma conta? Entrar",
  or_email: "ou com e-mail",
  error_title: "Erro de cadastro",
  errors: {
    name_required: "O nome é obrigatório",
    name_too_long: "O nome é muito longo (máximo 100 caracteres)",
    email_required: "O e-mail é obrigatório",
    email_invalid: "E-mail inválido",
    email_exists: "Já existe uma conta com este e-mail",
    password_min_length: "A senha deve ter pelo menos 8 caracteres",
    password_uppercase: "A senha deve conter pelo menos uma letra maiúscula",
    password_lowercase: "A senha deve conter pelo menos uma letra minúscula",
    password_number: "A senha deve conter pelo menos um número",
    confirm_password_required: "Por favor, confirme sua senha",
    passwords_mismatch: "As senhas não coincidem",
    terms_required: "Você deve aceitar os termos e condições",
    validation_error: "Erro de validação. Verifique os campos.",
    rate_limited: "Muitas tentativas. Tente novamente mais tarde.",
    generic: "Ocorreu um erro. Tente novamente."
  },
  verification: {
    title: "Verifique seu e-mail",
    message: "Enviamos um link de verificação para {{email}}. Por favor, verifique sua caixa de entrada.",
    resend_button: "Reenviar e-mail de verificação",
    resend_sent: "E-mail enviado",
    resend_success: "Reenviamos o e-mail de verificação.",
    resend_error: "Falha ao reenviar. Tente novamente.",
    back_to_login: "Voltar para entrar"
  }
}, bn = {
  strength: {
    label: "Força da senha",
    weak: "Fraca",
    fair: "Regular",
    good: "Boa",
    strong: "Forte"
  },
  requirements: {
    length: "Mínimo 8 caracteres",
    uppercase: "Pelo menos uma letra maiúscula",
    lowercase: "Pelo menos uma letra minúscula",
    number: "Pelo menos um número"
  }
}, yn = {
  loading: "Verificando autenticação...",
  unauthorized_title: "Acesso Negado",
  unauthorized_message: "Você não tem permissão para acessar esta página.",
  go_back: "Voltar",
  go_home: "Ir para Início"
}, vn = {
  menuLabel: "Menu do usuário",
  profile: "Meu Perfil",
  orders: "Meus Pedidos",
  finances: "Minhas Finanças",
  logout: "Sair",
  logoutConfirmTitle: "Sair",
  logoutConfirmMessage: "Tem certeza de que deseja sair?",
  cancel: "Cancelar",
  logout_success_title: "Sessão encerrada",
  logout_success_message: "Você saiu com sucesso"
}, kn = {
  title: "Entrar na TeleTienda",
  register_title: "Criar conta TeleTienda",
  continue_to: "para continuar em {{domain}}",
  redirecting: "Redirecionando para {{domain}}...",
  code_error: "Falha ao completar a autenticação. Por favor, tente novamente."
}, An = {
  divider: "ou continuar com",
  processing: "Entrando...",
  error_title: "Falha na autenticação",
  google: {
    button: "Entrar com Google",
    signup_button: "Cadastrar com Google"
  },
  facebook: {
    button: "Entrar com Facebook",
    signup_button: "Cadastrar com Facebook"
  },
  telegram: {
    button: "Entrar com Telegram",
    signup_button: "Cadastrar com Telegram",
    loading: "Carregando Telegram...",
    load_timeout: "O widget do Telegram não pôde carregar. Tente recarregar a página."
  },
  errors: {
    provider_denied: "Acesso negado: {{error}}",
    unknown_provider: "Provedor de autenticação desconhecido",
    missing_code: "Código de autorização ausente",
    telegram_no_redirect: "O Telegram não suporta fluxo de redirecionamento",
    popup_blocked: "A janela pop-up foi bloqueada. Permita pop-ups e tente novamente.",
    network: "Erro de rede. Verifique sua conexão.",
    generic: "Falha na autenticação. Tente novamente."
  }
}, Tn = {
  login: _n,
  register: wn,
  password: bn,
  guard: yn,
  userMenu: vn,
  portal: kn,
  oauth: An
}, Cn = ["es", "en", "ru", "pt"], _i = "es", Nt = {
  es: { auth: Xo },
  en: { auth: ln },
  ru: { auth: pn },
  pt: { auth: Tn }
};
function wi(e) {
  return Nt[e];
}
function bi(e) {
  for (const t of Cn)
    e.addResourceBundle(t, "auth", Nt[t].auth, !0, !1);
}
export {
  Un as ALL_ADMIN_ROLES,
  zr as AUTH_STORAGE_NAME,
  R as AuthApiError,
  gi as AuthCallbackPage,
  Do as AuthGuard,
  mi as AuthProvider,
  ur as COOKIE_MAX_AGE,
  ye as COOKIE_MAX_SIZE,
  Me as COOKIE_WARNING_THRESHOLD,
  De as CROSS_SUBDOMAIN_SYNC_COOKIE,
  dr as CROSS_SUBDOMAIN_SYNC_INTERVAL,
  _i as DEFAULT_LANGUAGE,
  vo as FacebookLoginButton,
  yo as GoogleLoginButton,
  dt as LoadingFallback,
  Pt as LoginForm,
  ii as LoginModal,
  ai as LoginPage,
  lr as MERCHANT_ADMIN_ROLES,
  _t as PLATFORM_ADMIN_ROLES,
  mr as PRODUCTION_DOMAIN,
  Lo as PasswordStrengthIndicator,
  ci as ProtectedRoute,
  Ot as RETURN_URL_PARAM,
  Oo as RegisterForm,
  si as RegisterModal,
  Ue as SLIM_AUTH_COOKIE_NAME,
  we as STORAGE_KEY,
  Cn as SUPPORTED_LANGUAGES,
  cr as SYNC_CHANNEL_NAME,
  Lt as SocialLoginButtons,
  ko as TelegramLoginButton,
  ct as UnauthorizedFallback,
  Ho as UserAvatar,
  di as UserMenu,
  xo as VerificationSuccess,
  bi as addAuthTranslations,
  pr as areCookiesEnabled,
  ri as authFetch,
  Nt as authTranslations,
  Ar as broadcastCrossSubdomainLogin,
  Tr as broadcastCrossSubdomainLogout,
  Cr as broadcastCrossSubdomainTokenRefresh,
  br as broadcastLogin,
  it as broadcastLogout,
  yr as broadcastTokenRefresh,
  No as buildRedirectUrl,
  So as calculatePasswordStrength,
  Xe as checkPasswordRequirements,
  Lr as checkStorageHealth,
  ce as clearAuthStorage,
  Rr as configureAuthApi,
  ti as configureHttpClient,
  Nr as createAuthStoreSlice,
  Tt as createAuthenticatedClient,
  xr as createZustandStorage,
  zt as decodeToken,
  Se as deleteCookie,
  se as deleteSlimCookie,
  Br as facebookOAuthCallbackApi,
  X as fetchUserProfileApi,
  J as getApiClient,
  Vn as getApiConfig,
  le as getAuthStorage,
  wi as getAuthTranslations,
  Ae as getCookie,
  jn as getCookieJSON,
  yt as getCookieSizeInfo,
  qe as getCrossSubdomainSync,
  Fe as getCrossTabSync,
  Fo as getCurrentPath,
  Jr as getHttpClient,
  oi as getRefreshPromise,
  li as getReturnUrl,
  me as getSlimCookie,
  ue as getStorageConfig,
  Xn as getStorageHealth,
  Eo as getStrengthColor,
  Ro as getStrengthLabel,
  Mt as getTokenExpiration,
  pi as getTokenTTL,
  fi as getUserGuidFromToken,
  At as googleOAuthCallbackApi,
  Pr as hasFullUserData,
  vt as hydrateFromApi,
  Dr as initAuthSync,
  Kn as isHydrationNeeded,
  Wn as isPrivateBrowsing,
  Uo as isRedirectLoop,
  Sr as isSlimAuthData,
  Qn as isTokenExpired,
  hi as isTokenExpiredFromString,
  et as isValidReturnUrl,
  Hr as loginApi,
  $r as loginByCodeApi,
  Ao as loginSchema,
  Gr as logoutApi,
  Zn as needsTokenRefresh,
  wr as onAuthSync,
  kr as onCrossSubdomainSync,
  fr as parseCookies,
  qo as performRedirect,
  Ze as refreshTokenApi,
  kt as registerApi,
  Po as registerSchema,
  jr as requestLoginCodeApi,
  Jn as resetAuthStorage,
  Bn as resetCrossSubdomainSync,
  $n as resetCrossTabSync,
  ei as resetHttpClientState,
  ni as resetRefreshPromise,
  Hn as resetStorageConfig,
  Ye as setCookie,
  Gn as setCookieJSON,
  Er as setSlimCookie,
  Yn as setStorageAdapter,
  Dn as setStorageConfig,
  Ir as setTokenGetter,
  Vr as telegramOAuthCallbackApi,
  Y as transformApiUser,
  St as useAuth,
  ui as useAuthContext,
  Zr as useAuthGuard,
  y as useAuthStore,
  so as useFacebookAuth,
  ao as useGoogleAuth,
  Yr as useHasHydrated,
  lo as useTelegramAuth,
  to as useTokenRefresh
};
//# sourceMappingURL=index.es.js.map
